// // import React, { useState } from 'react';
// // import { useParams, Link } from 'react-router-dom';
// // import { 
// //   ArrowLeft,
// //   CheckCircle,
// //   Clock,
// //   Phone,
// //   Mail,
// //   Calendar,
// //   ChevronDown,
// //   ChevronUp,
// //   Award,
// //   Shield,
// //   Users,
// //   AlertCircle,
// //   Info,
// //   Heart
// // } from 'lucide-react';

// // const ServiceDetailPage = () => {
// //   const { serviceId } = useParams();
// //   const [openFAQ, setOpenFAQ] = useState(null);

// //   // Service data with complete details
// //   const servicesData = {
// //     'chest-xray': {
// //       title: "Chest X-Ray",
// //       category: "Diagnostic Imaging",
// //       tagline: "Advanced Digital Radiography for Accurate Diagnosis",
// //       heroImage: "https://images.unsplash.com/photo-1530497610245-94d3c16cda28?w=1200&q=90",
// //       icon: "🔬",
// //       color: "#E86A33",
// //       duration: "15-20 minutes",
// //       preparation: "No special preparation required",
// //       overview: "Our state-of-the-art digital X-ray technology provides comprehensive chest imaging for accurate diagnosis of respiratory conditions, lung infections, and structural abnormalities. With minimal radiation exposure and immediate results, we ensure quick and reliable diagnostic services.",
// //       whatWeOffer: [
// //         "High-resolution digital X-ray imaging",
// //         "Same-day results with expert radiologist reports",
// //         "Low radiation exposure technology",
// //         "Portable X-ray services available",
// //         "Comparison with previous images",
// //         "Digital archiving for easy access"
// //       ],
// //       problemsSolved: [
// //         {
// //           title: "Respiratory Infections",
// //           description: "Detect pneumonia, tuberculosis, and other lung infections early for prompt treatment"
// //         },
// //         {
// //           title: "Lung Conditions",
// //           description: "Identify COPD, emphysema, bronchitis, and other chronic lung diseases"
// //         },
// //         {
// //           title: "Heart Issues",
// //           description: "Assess heart size, shape, and detect fluid around the heart"
// //         },
// //         {
// //           title: "Bone Problems",
// //           description: "Detect rib fractures, spine abnormalities, and chest wall issues"
// //         }
// //       ],
// //       procedure: [
// //         "You'll be asked to remove jewelry and metal objects",
// //         "Stand or sit in front of the X-ray machine",
// //         "Follow breathing instructions from the technician",
// //         "Images are captured in just a few seconds",
// //         "You can resume normal activities immediately"
// //       ],
// //       faqs: [
// //         {
// //           question: "Is chest X-ray safe?",
// //           answer: "Yes, chest X-rays are very safe. The amount of radiation exposure is minimal and the benefits of accurate diagnosis far outweigh the risks. Our modern equipment uses the lowest possible radiation doses."
// //         },
// //         {
// //           question: "Do I need to prepare for a chest X-ray?",
// //           answer: "No special preparation is needed. You can eat and drink normally. Just wear comfortable clothing and remove any jewelry or metal objects from your chest area."
// //         },
// //         {
// //           question: "How long does it take to get results?",
// //           answer: "Digital X-ray results are available within a few hours. Our radiologist will review the images and provide a detailed report the same day. Urgent cases are prioritized."
// //         },
// //         {
// //           question: "Can pregnant women have chest X-rays?",
// //           answer: "We generally avoid X-rays during pregnancy unless absolutely necessary. Please inform us if you are or might be pregnant, and we'll discuss safer alternatives with your doctor."
// //         },
// //         {
// //           question: "How often can I have a chest X-ray?",
// //           answer: "The frequency depends on your medical condition. Your doctor will determine the appropriate timing. Modern equipment uses very low radiation, making it safe for regular monitoring when medically necessary."
// //         }
// //       ]
// //     },
// //     'pft': {
// //       title: "PFT (Pulmonary Function Test)",
// //       category: "Respiratory Testing",
// //       tagline: "Comprehensive Lung Function Evaluation",
// //       heroImage: "https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=1200&q=90",
// //       icon: "🫁",
// //       color: "#2C85B8",
// //       duration: "30-45 minutes",
// //       preparation: "Avoid heavy meals 2 hours before test",
// //       overview: "Complete pulmonary function testing to measure lung capacity, airflow rates, and gas exchange efficiency. Essential for diagnosing and monitoring respiratory conditions like asthma, COPD, and interstitial lung diseases. Our comprehensive testing provides detailed insights into your lung health.",
// //       whatWeOffer: [
// //         "Spirometry testing with advanced equipment",
// //         "Lung volume measurement",
// //         "Diffusion capacity testing (DLCO)",
// //         "Exercise testing for respiratory assessment",
// //         "Pre and post-bronchodilator testing",
// //         "Detailed analysis reports with interpretation"
// //       ],
// //       problemsSolved: [
// //         {
// //           title: "Asthma Management",
// //           description: "Accurately diagnose asthma severity and monitor treatment effectiveness"
// //         },
// //         {
// //           title: "COPD Monitoring",
// //           description: "Track disease progression and optimize treatment plans for COPD patients"
// //         },
// //         {
// //           title: "Occupational Lung Disease",
// //           description: "Assess workplace exposure effects and monitor lung health"
// //         },
// //         {
// //           title: "Pre-Surgery Evaluation",
// //           description: "Determine lung function before surgery to ensure safety"
// //         }
// //       ],
// //       procedure: [
// //         "Avoid using inhalers 4-6 hours before test (unless instructed)",
// //         "You'll be seated comfortably and fitted with a mouthpiece",
// //         "Follow breathing instructions carefully",
// //         "Perform various breathing maneuvers as directed",
// //         "Test may be repeated for accuracy",
// //         "Bronchodilator may be given to test response"
// //       ],
// //       faqs: [
// //         {
// //           question: "Is the PFT test painful?",
// //           answer: "No, PFT is completely painless and non-invasive. You'll simply breathe into a mouthpiece following our technician's instructions. Some people may feel slightly out of breath during certain maneuvers, but this is temporary and normal."
// //         },
// //         {
// //           question: "Can I use my inhaler before the test?",
// //           answer: "Please avoid using short-acting inhalers 4-6 hours before the test and long-acting inhalers 12 hours before. However, if you're having severe breathing difficulty, use your inhaler and inform us. We may need to reschedule."
// //         },
// //         {
// //           question: "How should I prepare for PFT?",
// //           answer: "Avoid heavy meals 2 hours before the test, wear loose comfortable clothing, and avoid smoking for at least 1 hour before. Take your regular medications unless specifically instructed otherwise by your doctor."
// //         },
// //         {
// //           question: "Why do I need to repeat the breathing tests?",
// //           answer: "We typically perform each maneuver 3 times to ensure accuracy and consistency. This helps us get the most reliable measurements of your lung function."
// //         },
// //         {
// //           question: "When will I get my results?",
// //           answer: "Results are typically available within 24 hours. Your doctor will receive a detailed report with interpretation and recommendations for your treatment plan."
// //         }
// //       ]
// //     },
// //     'ecg': {
// //       title: "ECG (Electrocardiogram)",
// //       category: "Cardiac Testing",
// //       tagline: "Comprehensive Heart Monitoring",
// //       heroImage: "https://images.unsplash.com/photo-1628595351029-c2bf17511435?w=1200&q=90",
// //       icon: "❤️",
// //       color: "#E63946",
// //       duration: "10-15 minutes",
// //       preparation: "No special preparation needed",
// //       overview: "Non-invasive cardiac monitoring to detect arrhythmias, heart disease, and circulation issues. Our 12-lead ECG provides immediate results for accurate cardiac assessment, helping identify heart problems early and monitor treatment effectiveness.",
// //       whatWeOffer: [
// //         "12-lead ECG with latest technology",
// //         "Immediate digital results",
// //         "Arrhythmia detection and analysis",
// //         "Heart health comprehensive assessment",
// //         "Comparison with previous ECGs",
// //         "Expert cardiologist review and interpretation"
// //       ],
// //       problemsSolved: [
// //         {
// //           title: "Heart Rhythm Disorders",
// //           description: "Detect irregular heartbeats, atrial fibrillation, and other arrhythmias"
// //         },
// //         {
// //           title: "Heart Attack Screening",
// //           description: "Identify signs of past or ongoing heart attacks for immediate intervention"
// //         },
// //         {
// //           title: "Heart Disease Monitoring",
// //           description: "Track coronary artery disease, heart failure, and valve problems"
// //         },
// //         {
// //           title: "Medication Effects",
// //           description: "Monitor how heart medications are affecting your cardiac function"
// //         }
// //       ],
// //       procedure: [
// //         "Wear comfortable, loose-fitting clothing",
// //         "Electrodes are placed on chest, arms, and legs",
// //         "You'll lie still for a few minutes during recording",
// //         "The test is completely painless",
// //         "Results are available immediately",
// //         "You can resume all normal activities right away"
// //       ],
// //       faqs: [
// //         {
// //           question: "Is an ECG test safe?",
// //           answer: "Yes, ECG is completely safe and non-invasive. It only records your heart's electrical activity and doesn't send any electricity into your body. There are no risks or side effects."
// //         },
// //         {
// //           question: "Do I need to prepare for an ECG?",
// //           answer: "No special preparation is needed. Just avoid using oily or greasy lotions on your chest as they may interfere with electrode placement. Wear comfortable clothing that allows easy access to your chest."
// //         },
// //         {
// //           question: "What can an ECG detect?",
// //           answer: "An ECG can detect irregular heart rhythms, heart attacks (past or present), heart enlargement, inadequate blood or oxygen supply to the heart, and various other cardiac conditions."
// //         },
// //         {
// //           question: "How long does an ECG take?",
// //           answer: "The actual recording takes only about 5-10 minutes. With preparation and electrode placement, the entire process typically takes 10-15 minutes."
// //         },
// //         {
// //           question: "Will I get results immediately?",
// //           answer: "Yes, the ECG recording is available immediately. Our cardiologist will review it and provide a detailed interpretation report, usually within a few hours for routine cases."
// //         }
// //       ]
// //     },
// //     '2d-echo': {
// //       title: "2D ECHO (Echocardiography)",
// //       category: "Cardiac Imaging",
// //       tagline: "Advanced Heart Imaging Technology",
// //       heroImage: "https://images.unsplash.com/photo-1559757175-5700dde675bc?w=1200&q=90",
// //       icon: "🫀",
// //       color: "#1B4965",
// //       duration: "30-45 minutes",
// //       preparation: "No fasting required",
// //       overview: "Sophisticated ultrasound imaging providing real-time visualization of heart structure, function, and blood flow patterns. Essential for evaluating heart valves, chambers, and overall cardiac performance with detailed Doppler studies and color flow mapping.",
// //       whatWeOffer: [
// //         "Real-time heart imaging with latest equipment",
// //         "Valve function detailed assessment",
// //         "Chamber size and wall motion analysis",
// //         "Blood flow velocity evaluation",
// //         "Doppler studies for comprehensive analysis",
// //         "Color flow mapping for visualization"
// //       ],
// //       problemsSolved: [
// //         {
// //           title: "Valve Problems",
// //           description: "Detect valve stenosis, regurgitation, and structural abnormalities"
// //         },
// //         {
// //           title: "Heart Muscle Disease",
// //           description: "Assess cardiomyopathy, heart failure, and muscle function"
// //         },
// //         {
// //           title: "Congenital Defects",
// //           description: "Identify birth defects and structural heart problems"
// //         },
// //         {
// //           title: "Blood Clots",
// //           description: "Detect blood clots in heart chambers and assess stroke risk"
// //         }
// //       ],
// //       procedure: [
// //         "No fasting required, eat normally before test",
// //         "Lie on your left side on examination table",
// //         "Gel is applied to chest for better ultrasound contact",
// //         "Transducer is moved across chest to capture images",
// //         "You may be asked to change positions",
// //         "The test is painless and takes 30-45 minutes"
// //       ],
// //       faqs: [
// //         {
// //           question: "Is 2D Echo safe?",
// //           answer: "Yes, echocardiography is completely safe. It uses sound waves (ultrasound) to create images, not radiation. There are no known risks or side effects. It's even safe during pregnancy."
// //         },
// //         {
// //           question: "Do I need to fast before 2D Echo?",
// //           answer: "No, fasting is not required for a standard 2D echo. You can eat and drink normally. However, for a transesophageal echo (TEE), fasting is required - we'll inform you if this type is needed."
// //         },
// //         {
// //           question: "What's the difference between Echo and ECG?",
// //           answer: "ECG records electrical activity of the heart, while Echo creates actual images of heart structure and function using ultrasound. Both are important but provide different information."
// //         },
// //         {
// //           question: "Will the test hurt?",
// //           answer: "No, the test is painless. You'll feel the transducer moving across your chest and may feel slight pressure, but there's no pain or discomfort. The gel may feel cool on your skin."
// //         },
// //         {
// //           question: "How long before I get results?",
// //           answer: "Preliminary findings are often discussed immediately after the test. A complete report with detailed analysis is typically ready within 24 hours and sent to your referring doctor."
// //         }
// //       ]
// //     },
// //     'allergy-testing': {
// //       title: "Allergy Testing",
// //       category: "Immunology",
// //       tagline: "Comprehensive Allergen Identification",
// //       heroImage: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=1200&q=90",
// //       icon: "🤧",
// //       color: "#FF9B6E",
// //       duration: "45-60 minutes",
// //       preparation: "Avoid antihistamines 3-5 days before",
// //       overview: "Advanced allergy testing through skin prick tests and blood analysis to identify specific allergens causing your symptoms. Helps create personalized treatment and prevention plans for better allergy management and quality of life.",
// //       whatWeOffer: [
// //         "Skin prick testing for immediate allergies",
// //         "IgE blood tests for comprehensive analysis",
// //         "Food allergy panel testing",
// //         "Environmental allergen identification",
// //         "Drug allergy testing when needed",
// //         "Detailed allergy report with recommendations"
// //       ],
// //       problemsSolved: [
// //         {
// //           title: "Seasonal Allergies",
// //           description: "Identify pollen, grass, and mold allergies causing seasonal symptoms"
// //         },
// //         {
// //           title: "Food Allergies",
// //           description: "Pinpoint specific food allergies causing digestive or skin reactions"
// //         },
// //         {
// //           title: "Skin Conditions",
// //           description: "Find allergens causing eczema, hives, and other skin reactions"
// //         },
// //         {
// //           title: "Asthma Triggers",
// //           description: "Identify allergens that trigger or worsen asthma symptoms"
// //         }
// //       ],
// //       procedure: [
// //         "Stop antihistamines 3-5 days before test (consult doctor)",
// //         "Small amounts of allergens applied to forearm or back",
// //         "Wait 15-20 minutes for reactions to develop",
// //         "Results are read and documented",
// //         "Blood test may be done if needed",
// //         "Detailed discussion of results and treatment plan"
// //       ],
// //       faqs: [
// //         {
// //           question: "Is allergy testing painful?",
// //           answer: "Skin prick testing causes minimal discomfort - you'll feel a slight prick or scratch. Most people describe it as less painful than a vaccination. Blood testing is similar to a routine blood draw."
// //         },
// //         {
// //           question: "Why should I stop taking antihistamines?",
// //           answer: "Antihistamines can block allergic reactions and give false negative results. Stop them 3-5 days before testing (longer for some medications). Always consult your doctor before stopping any medication."
// //         },
// //         {
// //           question: "Can children have allergy testing?",
// //           answer: "Yes, children as young as 6 months can be tested. We use age-appropriate methods and our staff is trained in pediatric allergy testing to ensure comfort and accuracy."
// //         },
// //         {
// //           question: "What if I have a severe reaction during testing?",
// //           answer: "Testing is done under medical supervision with emergency equipment readily available. Reactions during testing are usually mild and limited to the test site. Severe reactions are extremely rare."
// //         },
// //         {
// //           question: "How accurate is allergy testing?",
// //           answer: "Skin prick testing is 85-90% accurate for most common allergens. Combined with your medical history and symptoms, it provides reliable identification of your specific allergies."
// //         }
// //       ]
// //     },
// //     'bronchoscopy': {
// //       title: "Bronchoscopy",
// //       category: "Interventional",
// //       tagline: "Advanced Airway Visualization",
// //       heroImage: "https://images.unsplash.com/photo-1582560475093-ba66accbc424?w=1200&q=90",
// //       icon: "🔬",
// //       color: "#2C5F7C",
// //       duration: "30-60 minutes",
// //       preparation: "Fasting 6 hours before procedure",
// //       overview: "Minimally invasive procedure using a flexible bronchoscope to examine airways, collect samples, and perform therapeutic interventions. Performed under sedation for patient comfort, allowing detailed examination and treatment of respiratory conditions.",
// //       whatWeOffer: [
// //         "Flexible bronchoscopy with advanced equipment",
// //         "Diagnostic and therapeutic procedures",
// //         "Tissue biopsy for accurate diagnosis",
// //         "Bronchoalveolar lavage (BAL)",
// //         "Foreign body removal when needed",
// //         "Conscious sedation for comfort"
// //       ],
// //       problemsSolved: [
// //         {
// //           title: "Persistent Cough",
// //           description: "Investigate and treat chronic cough with unknown cause"
// //         },
// //         {
// //           title: "Lung Infections",
// //           description: "Collect samples to identify specific infections and guide treatment"
// //         },
// //         {
// //           title: "Lung Cancer",
// //           description: "Obtain tissue samples for cancer diagnosis and staging"
// //         },
// //         {
// //           title: "Airway Obstruction",
// //           description: "Remove foreign bodies and treat narrowed airways"
// //         }
// //       ],
// //       procedure: [
// //         "Fast for 6 hours before procedure",
// //         "Local anesthetic applied to throat and nose",
// //         "Sedative given for comfort and relaxation",
// //         "Flexible bronchoscope inserted through nose or mouth",
// //         "Airways examined and samples collected if needed",
// //         "Recovery in observation area for 1-2 hours"
// //       ],
// //       faqs: [
// //         {
// //           question: "Is bronchoscopy painful?",
// //           answer: "No, the procedure is performed under sedation and local anesthesia. You may feel slight pressure or urge to cough, but it shouldn't be painful. Most patients don't remember the procedure afterward."
// //         },
// //         {
// //           question: "How should I prepare for bronchoscopy?",
// //           answer: "Fast for at least 6 hours before the procedure. Inform your doctor about all medications, especially blood thinners. Arrange for someone to drive you home as you'll be sedated."
// //         },
// //         {
// //           question: "What are the risks of bronchoscopy?",
// //           answer: "Bronchoscopy is very safe. Rare complications may include minor bleeding, reaction to sedation, or temporary breathing difficulty. Our experienced team minimizes these risks."
// //         },
// //         {
// //           question: "How long is the recovery?",
// //           answer: "Most people recover quickly. You'll be monitored for 1-2 hours after the procedure. Avoid eating or drinking for 2 hours. Some throat soreness or cough is normal for 1-2 days."
// //         },
// //         {
// //           question: "When will I get biopsy results?",
// //           answer: "Initial findings are available immediately. Biopsy results typically take 3-7 days as they require laboratory analysis. Your doctor will discuss results and treatment plan with you."
// //         }
// //       ]
// //     },
// //     'thoracoscopy': {
// //       title: "Thoracoscopy",
// //       category: "Surgical",
// //       tagline: "Minimally Invasive Chest Surgery",
// //       heroImage: "https://images.unsplash.com/photo-1579154204601-01588f351e67?w=1200&q=90",
// //       icon: "🏥",
// //       color: "#62B6CB",
// //       duration: "1-2 hours",
// //       preparation: "Pre-operative evaluation required",
// //       overview: "Advanced minimally invasive surgical procedure for diagnosis and treatment of chest conditions. Uses small incisions and a camera for better visualization and faster recovery compared to traditional surgery.",
// //       whatWeOffer: [
// //         "Video-assisted thoracic surgery (VATS)",
// //         "Minimal scarring with small incisions",
// //         "Faster recovery than open surgery",
// //         "Pleural biopsy for diagnosis",
// //         "Fluid drainage and pleurodesis",
// //         "Expert surgical team with experience"
// //       ],
// //       problemsSolved: [
// //         {
// //           title: "Pleural Effusion",
// //           description: "Diagnose and treat fluid accumulation around lungs"
// //         },
// //         {
// //           title: "Lung Nodules",
// //           description: "Remove suspicious lung nodules for diagnosis"
// //         },
// //         {
// //           title: "Pneumothorax",
// //           description: "Treat collapsed lung and prevent recurrence"
// //         },
// //         {
// //           title: "Pleural Disease",
// //           description: "Diagnose and treat various pleural conditions"
// //         }
// //       ],
// //       procedure: [
// //         "Pre-operative evaluation and tests",
// //         "General anesthesia administered",
// //         "Small incisions (1-2 cm) made in chest wall",
// //         "Camera and instruments inserted",
// //         "Surgical procedure performed",
// //         "Hospital stay typically 1-3 days"
// //       ],
// //       faqs: [
// //         {
// //           question: "Is thoracoscopy better than open surgery?",
// //           answer: "Yes, in most cases. Thoracoscopy offers less pain, smaller scars, faster recovery, and shorter hospital stay compared to open surgery, while providing excellent visualization and results."
// //         },
// //         {
// //           question: "How long is the recovery period?",
// //           answer: "Most patients return to light activities within 1-2 weeks and full activities within 4-6 weeks. Recovery is much faster than traditional open chest surgery which can take 2-3 months."
// //         },
// //         {
// //           question: "Will I have chest tubes after surgery?",
// //           answer: "Usually yes, a chest tube is placed during surgery to drain fluid and air. It typically stays for 1-3 days and is removed before hospital discharge once drainage is minimal."
// //         },
// //         {
// //           question: "What are the risks of thoracoscopy?",
// //           answer: "While generally safe, risks include bleeding, infection, air leak, and rarely, need for conversion to open surgery. Our experienced surgical team minimizes these risks with careful technique."
// //         },
// //         {
// //           question: "How long will I stay in hospital?",
// //           answer: "Most thoracoscopy patients stay 1-3 days depending on the procedure and recovery. Some simple procedures may allow same-day or next-day discharge."
// //         }
// //       ]
// //     }
// //   };

// //   const service = servicesData[serviceId];

// //   if (!service) {
// //     return (
// //       <div style={{padding: '4rem 2rem', textAlign: 'center'}}>
// //         <h2>Service not found</h2>
// //         <Link to="/services" style={{color: '#E86A33'}}>Back to Services</Link>
// //       </div>
// //     );
// //   }

// //   const toggleFAQ = (index) => {
// //     setOpenFAQ(openFAQ === index ? null : index);
// //   };

// //   return (
// //     <>
// //       <style>{`
// //         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700;800&family=Inter:wght@300;400;500;600;700;800&display=swap');
        
// //         * {
// //           margin: 0;
// //           padding: 0;
// //           box-sizing: border-box;
// //         }

// //         body {
// //           font-family: 'Inter', sans-serif;
// //           color: #1a1a1a;
// //         }

// //         .service-detail-page {
// //           width: 100%;
// //           min-height: 100vh;
// //           background: linear-gradient(135deg, #F8FAFB 0%, white 100%);
// //         }

// //         /* Hero Section */
// //         .service-hero {
// //           position: relative;
// //           height: 70vh;
// //           min-height: 500px;
// //           background-size: cover;
// //           background-position: center;
// //           display: flex;
// //           align-items: center;
// //           justify-content: center;
// //           overflow: hidden;
// //         }

// //         .service-hero::before {
// //           content: '';
// //           position: absolute;
// //           top: 0;
// //           left: 0;
// //           right: 0;
// //           bottom: 0;
// //           background: linear-gradient(135deg, rgba(27, 73, 101, 0.9) 0%, rgba(44, 95, 124, 0.85) 100%);
// //         }

// //         .service-hero-content {
// //           position: relative;
// //           z-index: 2;
// //           text-align: center;
// //           color: white;
// //           max-width: 1000px;
// //           padding: 2rem;
// //         }

// //         .back-link {
// //           display: inline-flex;
// //           align-items: center;
// //           gap: 0.5rem;
// //           color: white;
// //           text-decoration: none;
// //           font-weight: 600;
// //           margin-bottom: 2rem;
// //           padding: 0.8rem 1.5rem;
// //           background: rgba(255, 255, 255, 0.1);
// //           backdrop-filter: blur(10px);
// //           border-radius: 50px;
// //           border: 1px solid rgba(255, 255, 255, 0.2);
// //           transition: all 0.3s ease;
// //         }

// //         .back-link:hover {
// //           background: rgba(255, 255, 255, 0.2);
// //           transform: translateX(-5px);
// //         }

// //         .service-icon-large {
// //           font-size: 5rem;
// //           margin-bottom: 1rem;
// //           animation: float 3s ease-in-out infinite;
// //         }

// //         @keyframes float {
// //           0%, 100% { transform: translateY(0); }
// //           50% { transform: translateY(-10px); }
// //         }

// //         .service-category-badge {
// //           display: inline-block;
// //           padding: 0.5rem 1.5rem;
// //           background: rgba(255, 155, 110, 0.2);
// //           border: 1px solid rgba(255, 155, 110, 0.4);
// //           border-radius: 50px;
// //           color: #FFD700;
// //           font-size: 0.9rem;
// //           font-weight: 700;
// //           letter-spacing: 2px;
// //           text-transform: uppercase;
// //           margin-bottom: 1.5rem;
// //         }

// //         .service-detail-title {
// //           font-family: 'Playfair Display', serif;
// //           font-size: 4rem;
// //           font-weight: 800;
// //           margin-bottom: 1rem;
// //           line-height: 1.1;
// //         }

// //         .service-tagline {
// //           font-size: 1.5rem;
// //           font-weight: 300;
// //           opacity: 0.95;
// //           margin-bottom: 2rem;
// //         }

// //         .service-meta {
// //           display: flex;
// //           gap: 3rem;
// //           justify-content: center;
// //           flex-wrap: wrap;
// //         }

// //         .meta-item {
// //           display: flex;
// //           align-items: center;
// //           gap: 0.7rem;
// //           font-size: 1.1rem;
// //         }

// //         /* Quick Contact Bar */
// //         .quick-contact-bar {
// //           position: sticky;
// //           top: 100px;
// //           z-index: 100;
// //           background: white;
// //           box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
// //           padding: 1.5rem 2rem;
// //           margin-top: -50px;
// //         }

// //         .quick-contact-content {
// //           max-width: 1400px;
// //           margin: 0 auto;
// //           display: flex;
// //           justify-content: space-between;
// //           align-items: center;
// //           gap: 2rem;
// //           flex-wrap: wrap;
// //         }

// //         .contact-info-compact {
// //           display: flex;
// //           gap: 2rem;
// //           flex-wrap: wrap;
// //         }

// //         .contact-item-compact {
// //           display: flex;
// //           align-items: center;
// //           gap: 0.7rem;
// //           font-size: 0.95rem;
// //           color: #1B4965;
// //           font-weight: 600;
// //         }

// //         .contact-item-compact a {
// //           color: #1B4965;
// //           text-decoration: none;
// //           transition: color 0.3s ease;
// //         }

// //         .contact-item-compact a:hover {
// //           color: #E86A33;
// //         }

// //         .book-button {
// //           padding: 1rem 2.5rem;
// //           background: linear-gradient(135deg, #E86A33, #FF9B6E);
// //           color: white;
// //           border: none;
// //           border-radius: 50px;
// //           font-weight: 700;
// //           font-size: 1rem;
// //           cursor: pointer;
// //           display: flex;
// //           align-items: center;
// //           gap: 0.7rem;
// //           transition: all 0.3s ease;
// //           box-shadow: 0 4px 15px rgba(232, 106, 51, 0.3);
// //           text-decoration: none;
// //         }

// //         .book-button:hover {
// //           transform: translateY(-2px);
// //           box-shadow: 0 6px 25px rgba(232, 106, 51, 0.4);
// //         }

// //         /* Main Content */
// //         .service-content {
// //           max-width: 1400px;
// //           margin: 0 auto;
// //           padding: 4rem 2rem;
// //         }

// //         .content-grid {
// //           display: grid;
// //           grid-template-columns: 2fr 1fr;
// //           gap: 4rem;
// //           align-items: start;
// //         }

// //         /* Sections */
// //         .content-section {
// //           background: white;
// //           border-radius: 25px;
// //           padding: 3rem;
// //           box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
// //           margin-bottom: 2rem;
// //         }

// //         .section-title {
// //           font-family: 'Playfair Display', serif;
// //           font-size: 2.5rem;
// //           font-weight: 800;
// //           color: #1B4965;
// //           margin-bottom: 1.5rem;
// //           display: flex;
// //           align-items: center;
// //           gap: 1rem;
// //         }

// //         .section-subtitle {
// //           font-size: 1.5rem;
// //           font-weight: 700;
// //           color: #1B4965;
// //           margin: 2rem 0 1rem;
// //         }

// //         .section-text {
// //           font-size: 1.1rem;
// //           line-height: 1.9;
// //           color: #666;
// //           margin-bottom: 2rem;
// //         }

// //         .feature-list {
// //           display: grid;
// //           gap: 1rem;
// //         }

// //         .feature-list-item {
// //           display: flex;
// //           align-items: flex-start;
// //           gap: 1rem;
// //           padding: 1rem;
// //           background: #F8FAFB;
// //           border-radius: 12px;
// //           transition: all 0.3s ease;
// //         }

// //         .feature-list-item:hover {
// //           background: #fff;
// //           box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
// //           transform: translateX(5px);
// //         }

// //         .feature-icon {
// //           color: #E86A33;
// //           flex-shrink: 0;
// //           margin-top: 0.2rem;
// //         }

// //         .feature-text {
// //           font-size: 1.05rem;
// //           line-height: 1.7;
// //           color: #1a1a1a;
// //         }

// //         /* Problems Solved */
// //         .problems-grid {
// //           display: grid;
// //           grid-template-columns: repeat(2, 1fr);
// //           gap: 1.5rem;
// //           margin-top: 2rem;
// //         }

// //         .problem-card {
// //           padding: 2rem;
// //           background: linear-gradient(135deg, #F8FAFB 0%, white 100%);
// //           border-radius: 20px;
// //           border-left: 4px solid #E86A33;
// //           transition: all 0.3s ease;
// //         }

// //         .problem-card:hover {
// //           transform: translateY(-5px);
// //           box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
// //         }

// //         .problem-title {
// //           font-size: 1.3rem;
// //           font-weight: 700;
// //           color: #1B4965;
// //           margin-bottom: 0.8rem;
// //           display: flex;
// //           align-items: center;
// //           gap: 0.7rem;
// //         }

// //         .problem-description {
// //           font-size: 1rem;
// //           line-height: 1.7;
// //           color: #666;
// //         }

// //         /* Procedure Steps */
// //         .procedure-steps {
// //           counter-reset: step-counter;
// //           display: flex;
// //           flex-direction: column;
// //           gap: 1.5rem;
// //           margin-top: 2rem;
// //         }

// //         .procedure-step {
// //           position: relative;
// //           padding-left: 5rem;
// //           padding: 1.5rem 1.5rem 1.5rem 5rem;
// //           background: #F8FAFB;
// //           border-radius: 15px;
// //           transition: all 0.3s ease;
// //         }

// //         .procedure-step:hover {
// //           background: white;
// //           box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
// //         }

// //         .procedure-step::before {
// //           counter-increment: step-counter;
// //           content: counter(step-counter);
// //           position: absolute;
// //           left: 1.5rem;
// //           top: 50%;
// //           transform: translateY(-50%);
// //           width: 45px;
// //           height: 45px;
// //           background: linear-gradient(135deg, #E86A33, #FF9B6E);
// //           color: white;
// //           border-radius: 50%;
// //           display: flex;
// //           align-items: center;
// //           justify-content: center;
// //           font-weight: 800;
// //           font-size: 1.3rem;
// //           font-family: 'Playfair Display', serif;
// //         }

// //         /* FAQ Section */
// //         .faq-list {
// //           display: flex;
// //           flex-direction: column;
// //           gap: 1rem;
// //         }

// //         .faq-item {
// //           background: white;
// //           border: 2px solid #f0f0f0;
// //           border-radius: 15px;
// //           overflow: hidden;
// //           transition: all 0.3s ease;
// //         }

// //         .faq-item.open {
// //           border-color: #E86A33;
// //           box-shadow: 0 5px 20px rgba(232, 106, 51, 0.1);
// //         }

// //         .faq-question {
// //           padding: 1.5rem 2rem;
// //           display: flex;
// //           justify-content: space-between;
// //           align-items: center;
// //           cursor: pointer;
// //           font-weight: 700;
// //           font-size: 1.1rem;
// //           color: #1B4965;
// //           transition: all 0.3s ease;
// //         }

// //         .faq-question:hover {
// //           color: #E86A33;
// //         }

// //         .faq-answer {
// //           padding: 0 2rem 1.5rem;
// //           font-size: 1.05rem;
// //           line-height: 1.8;
// //           color: #666;
// //           animation: slideDown 0.3s ease;
// //         }

// //         @keyframes slideDown {
// //           from {
// //             opacity: 0;
// //             transform: translateY(-10px);
// //           }
// //           to {
// //             opacity: 1;
// //             transform: translateY(0);
// //           }
// //         }

// //         /* Sidebar */
// //         .sidebar {
// //           position: sticky;
// //           top: 200px;
// //         }

// //         .sidebar-card {
// //           background: white;
// //           border-radius: 25px;
// //           padding: 2.5rem;
// //           box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
// //           margin-bottom: 2rem;
// //         }

// //         .sidebar-title {
// //           font-size: 1.5rem;
// //           font-weight: 700;
// //           color: #1B4965;
// //           margin-bottom: 1.5rem;
// //           font-family: 'Playfair Display', serif;
// //         }

// //         .info-item {
// //           display: flex;
// //           align-items: center;
// //           justify-content: space-between;
// //           padding: 1rem 0;
// //           border-bottom: 1px solid #f0f0f0;
// //         }

// //         .info-item:last-child {
// //           border-bottom: none;
// //         }

// //         .info-label {
// //           font-weight: 600;
// //           color: #666;
// //           font-size: 0.95rem;
// //         }

// //         .info-value {
// //           font-weight: 700;
// //           color: #1B4965;
// //           font-size: 1rem;
// //         }

// //         .cta-card {
// //           background: linear-gradient(135deg, #1B4965 0%, #2C5F7C 100%);
// //           color: white;
// //           text-align: center;
// //         }

// //         .cta-card-title {
// //           font-size: 1.8rem;
// //           font-weight: 800;
// //           margin-bottom: 1rem;
// //           font-family: 'Playfair Display', serif;
// //         }

// //         .cta-card-text {
// //           font-size: 1rem;
// //           opacity: 0.95;
// //           margin-bottom: 1.5rem;
// //           line-height: 1.7;
// //         }

// //         .cta-contact-list {
// //           display: flex;
// //           flex-direction: column;
// //           gap: 1rem;
// //           margin: 2rem 0;
// //         }

// //         .cta-contact-item {
// //           display: flex;
// //           align-items: center;
// //           gap: 1rem;
// //           padding: 1rem;
// //           background: rgba(255, 255, 255, 0.1);
// //           border-radius: 12px;
// //           font-weight: 600;
// //         }

// //         .cta-contact-item a {
// //           color: white;
// //           text-decoration: none;
// //         }

// //         .features-badge-list {
// //           display: flex;
// //           flex-wrap: wrap;
// //           gap: 0.8rem;
// //           margin-top: 1rem;
// //         }

// //         .feature-badge {
// //           padding: 0.6rem 1.2rem;
// //           background: #F8FAFB;
// //           border-radius: 50px;
// //           font-size: 0.9rem;
// //           font-weight: 600;
// //           color: #1B4965;
// //           display: flex;
// //           align-items: center;
// //           gap: 0.5rem;
// //         }

// //         /* Responsive */
// //         @media (max-width: 1024px) {
// //           .content-grid {
// //             grid-template-columns: 1fr;
// //           }

// //           .sidebar {
// //             position: relative;
// //             top: 0;
// //           }

// //           .problems-grid {
// //             grid-template-columns: 1fr;
// //           }
// //         }

// //         @media (max-width: 768px) {
// //           .service-detail-title {
// //             font-size: 2.5rem;
// //           }

// //           .service-tagline {
// //             font-size: 1.2rem;
// //           }

// //           .service-meta {
// //             flex-direction: column;
// //             gap: 1rem;
// //           }

// //           .quick-contact-content {
// //             flex-direction: column;
// //             align-items: flex-start;
// //           }

// //           .content-section {
// //             padding: 2rem;
// //           }

// //           .section-title {
// //             font-size: 2rem;
// //           }

// //           .procedure-step {
// //             padding-left: 4rem;
// //           }

// //           .procedure-step::before {
// //             width: 35px;
// //             height: 35px;
// //             font-size: 1.1rem;
// //             left: 1rem;
// //           }
// //         }
// //       `}</style>

// //       <div className="service-detail-page">
// //         {/* Hero Section */}
// //         <section 
// //           className="service-hero"
// //           style={{backgroundImage: `url(${service.heroImage})`}}
// //         >
// //           <div className="service-hero-content">
// //             <Link to="/services" className="back-link">
// //               <ArrowLeft size={20} />
// //               Back to Services
// //             </Link>
            
// //             <div className="service-icon-large">{service.icon}</div>
// //             <div className="service-category-badge">{service.category}</div>
// //             <h1 className="service-detail-title">{service.title}</h1>
// //             <p className="service-tagline">{service.tagline}</p>
            
// //             <div className="service-meta">
// //               <div className="meta-item">
// //                 <Clock size={20} />
// //                 <span>{service.duration}</span>
// //               </div>
// //               <div className="meta-item">
// //                 <AlertCircle size={20} />
// //                 <span>{service.preparation}</span>
// //               </div>
// //             </div>
// //           </div>
// //         </section>

// //         {/* Quick Contact Bar */}
// //         <div className="quick-contact-bar">
// //           <div className="quick-contact-content">
// //             <div className="contact-info-compact">
// //               <div className="contact-item-compact">
// //                 <Phone size={18} />
// //                 <a href="tel:+911234567890">+91 123 456 7890</a>
// //               </div>
// //               <div className="contact-item-compact">
// //                 <Phone size={18} />
// //                 <a href="tel:+910987654321">+91 098 765 4321</a>
// //               </div>
// //               <div className="contact-item-compact">
// //                 <Mail size={18} />
// //                 <a href="mailto:appointments@vayulungcare.com">appointments@vayulungcare.com</a>
// //               </div>
// //             </div>
// //             <a href="#book-appointment" className="book-button">
// //               <Calendar size={20} />
// //               Book Appointment
// //             </a>
// //           </div>
// //         </div>

// //         {/* Main Content */}
// //         <div className="service-content">
// //           <div className="content-grid">
// //             {/* Main Column */}
// //             <div>
// //               {/* Overview */}
// //               <div className="content-section">
// //                 <h2 className="section-title">
// //                   <Info size={32} />
// //                   Overview
// //                 </h2>
// //                 <p className="section-text">{service.overview}</p>
// //               </div>

// //               {/* What We Offer */}
// //               <div className="content-section">
// //                 <h2 className="section-title">
// //                   <Shield size={32} />
// //                   What We Offer
// //                 </h2>
// //                 <div className="feature-list">
// //                   {service.whatWeOffer.map((item, index) => (
// //                     <div key={index} className="feature-list-item">
// //                       <CheckCircle size={22} className="feature-icon" />
// //                       <span className="feature-text">{item}</span>
// //                     </div>
// //                   ))}
// //                 </div>
// //               </div>

// //               {/* Problems Solved */}
// //               <div className="content-section">
// //                 <h2 className="section-title">
// //                   <Heart size={32} />
// //                   Problems We Solve
// //                 </h2>
// //                 <div className="problems-grid">
// //                   {service.problemsSolved.map((problem, index) => (
// //                     <div key={index} className="problem-card">
// //                       <h3 className="problem-title">
// //                         <CheckCircle size={20} />
// //                         {problem.title}
// //                       </h3>
// //                       <p className="problem-description">{problem.description}</p>
// //                     </div>
// //                   ))}
// //                 </div>
// //               </div>

// //               {/* Procedure */}
// //               <div className="content-section">
// //                 <h2 className="section-title">
// //                   <Award size={32} />
// //                   What to Expect
// //                 </h2>
// //                 <div className="procedure-steps">
// //                   {service.procedure.map((step, index) => (
// //                     <div key={index} className="procedure-step">
// //                       {step}
// //                     </div>
// //                   ))}
// //                 </div>
// //               </div>

// //               {/* FAQs */}
// //               <div className="content-section">
// //                 <h2 className="section-title">
// //                   <AlertCircle size={32} />
// //                   Frequently Asked Questions
// //                 </h2>
// //                 <div className="faq-list">
// //                   {service.faqs.map((faq, index) => (
// //                     <div 
// //                       key={index} 
// //                       className={`faq-item ${openFAQ === index ? 'open' : ''}`}
// //                     >
// //                       <div 
// //                         className="faq-question"
// //                         onClick={() => toggleFAQ(index)}
// //                       >
// //                         <span>{faq.question}</span>
// //                         {openFAQ === index ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
// //                       </div>
// //                       {openFAQ === index && (
// //                         <div className="faq-answer">
// //                           {faq.answer}
// //                         </div>
// //                       )}
// //                     </div>
// //                   ))}
// //                 </div>
// //               </div>
// //             </div>

// //             {/* Sidebar */}
// //             <div className="sidebar">
// //               {/* Quick Info */}
// //               <div className="sidebar-card">
// //                 <h3 className="sidebar-title">Quick Information</h3>
// //                 <div className="info-item">
// //                   <span className="info-label">Duration</span>
// //                   <span className="info-value">{service.duration}</span>
// //                 </div>
// //                 <div className="info-item">
// //                   <span className="info-label">Category</span>
// //                   <span className="info-value">{service.category}</span>
// //                 </div>
// //                 <div className="info-item">
// //                   <span className="info-label">Preparation</span>
// //                   <span className="info-value">{service.preparation}</span>
// //                 </div>
// //               </div>

// //               {/* CTA Card */}
// //               <div className="sidebar-card cta-card" id="book-appointment">
// //                 <h3 className="cta-card-title">Ready to Book?</h3>
// //                 <p className="cta-card-text">
// //                   Schedule your appointment today and take the first step towards better health
// //                 </p>
                
// //                 <div className="cta-contact-list">
// //                   <div className="cta-contact-item">
// //                     <Phone size={20} />
// //                     <a href="tel:+911234567890">+91 123 456 7890</a>
// //                   </div>
// //                   <div className="cta-contact-item">
// //                     <Phone size={20} />
// //                     <a href="tel:+910987654321">+91 098 765 4321</a>
// //                   </div>
// //                   <div className="cta-contact-item">
// //                     <Mail size={20} />
// //                     <a href="mailto:appointments@vayulungcare.com">appointments@vayulungcare.com</a>
// //                   </div>
// //                 </div>

// //                 <button className="book-button" style={{width: '100%', justifyContent: 'center'}}>
// //                   <Calendar size={20} />
// //                   Book Now
// //                 </button>
// //               </div>

// //               {/* Other Services */}
// //               <div className="sidebar-card">
// //                 <h3 className="sidebar-title">Other Services</h3>
// //                 <div className="features-badge-list">
// //                   {Object.keys(servicesData)
// //                     .filter(key => key !== serviceId)
// //                     .slice(0, 6)
// //                     .map((key) => (
// //                       <Link 
// //                         key={key}
// //                         to={`/services/${key}`}
// //                         className="feature-badge"
// //                         style={{textDecoration: 'none'}}
// //                       >
// //                         {servicesData[key].icon}
// //                         {servicesData[key].title}
// //                       </Link>
// //                     ))}
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </>
// //   );
// // };

// // export default ServiceDetailPage;


// import React, { useState } from 'react';
// import { useParams, Link } from 'react-router-dom';
// import { 
//   ArrowLeft,
//   CheckCircle,
//   Clock,
//   Phone,
//   Mail,
//   Calendar,
//   ChevronDown,
//   ChevronUp,
//   Award,
//   Shield,
//   Users,
//   AlertCircle,
//   Info,
//   Heart
// } from 'lucide-react';

// const ServiceDetailPage = () => {
//   const { serviceId } = useParams();
//   const [openFAQ, setOpenFAQ] = useState(null);

//   // Service data with complete details
//   const servicesData = {
//     'chest-xray': {
//       title: "Chest X-Ray",
//       category: "Diagnostic Imaging",
//       tagline: "Advanced Digital Radiography for Accurate Diagnosis",
//       heroImage: "https://images.unsplash.com/photo-1530497610245-94d3c16cda28?w=1200&q=90",
//       icon: "🔬",
//       color: "#E86A33",
//       duration: "15-20 minutes",
//       preparation: "No special preparation required",
//       overview: "Our state-of-the-art digital X-ray technology provides comprehensive chest imaging for accurate diagnosis of respiratory conditions, lung infections, and structural abnormalities. With minimal radiation exposure and immediate results, we ensure quick and reliable diagnostic services.",
//       whatWeOffer: [
//         "High-resolution digital X-ray imaging",
//         "Same-day results with expert radiologist reports",
//         "Low radiation exposure technology",
//         "Portable X-ray services available",
//         "Comparison with previous images",
//         "Digital archiving for easy access"
//       ],
//       problemsSolved: [
//         {
//           title: "Respiratory Infections",
//           description: "Detect pneumonia, tuberculosis, and other lung infections early for prompt treatment"
//         },
//         {
//           title: "Lung Conditions",
//           description: "Identify COPD, emphysema, bronchitis, and other chronic lung diseases"
//         },
//         {
//           title: "Heart Issues",
//           description: "Assess heart size, shape, and detect fluid around the heart"
//         },
//         {
//           title: "Bone Problems",
//           description: "Detect rib fractures, spine abnormalities, and chest wall issues"
//         }
//       ],
//       procedure: [
//         "You'll be asked to remove jewelry and metal objects",
//         "Stand or sit in front of the X-ray machine",
//         "Follow breathing instructions from the technician",
//         "Images are captured in just a few seconds",
//         "You can resume normal activities immediately"
//       ],
//       faqs: [
//         {
//           question: "Is chest X-ray safe?",
//           answer: "Yes, chest X-rays are very safe. The amount of radiation exposure is minimal and the benefits of accurate diagnosis far outweigh the risks. Our modern equipment uses the lowest possible radiation doses."
//         },
//         {
//           question: "Do I need to prepare for a chest X-ray?",
//           answer: "No special preparation is needed. You can eat and drink normally. Just wear comfortable clothing and remove any jewelry or metal objects from your chest area."
//         },
//         {
//           question: "How long does it take to get results?",
//           answer: "Digital X-ray results are available within a few hours. Our radiologist will review the images and provide a detailed report the same day. Urgent cases are prioritized."
//         },
//         {
//           question: "Can pregnant women have chest X-rays?",
//           answer: "We generally avoid X-rays during pregnancy unless absolutely necessary. Please inform us if you are or might be pregnant, and we'll discuss safer alternatives with your doctor."
//         },
//         {
//           question: "How often can I have a chest X-ray?",
//           answer: "The frequency depends on your medical condition. Your doctor will determine the appropriate timing. Modern equipment uses very low radiation, making it safe for regular monitoring when medically necessary."
//         }
//       ]
//     },
//     'pft': {
//       title: "PFT (Pulmonary Function Test)",
//       category: "Respiratory Testing",
//       tagline: "Comprehensive Lung Function Evaluation",
//       heroImage: "https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=1200&q=90",
//       icon: "🫁",
//       color: "#2C85B8",
//       duration: "30-45 minutes",
//       preparation: "Avoid heavy meals 2 hours before test",
//       overview: "Complete pulmonary function testing to measure lung capacity, airflow rates, and gas exchange efficiency. Essential for diagnosing and monitoring respiratory conditions like asthma, COPD, and interstitial lung diseases. Our comprehensive testing provides detailed insights into your lung health.",
//       whatWeOffer: [
//         "Spirometry testing with advanced equipment",
//         "Lung volume measurement",
//         "Diffusion capacity testing (DLCO)",
//         "Exercise testing for respiratory assessment",
//         "Pre and post-bronchodilator testing",
//         "Detailed analysis reports with interpretation"
//       ],
//       problemsSolved: [
//         {
//           title: "Asthma Management",
//           description: "Accurately diagnose asthma severity and monitor treatment effectiveness"
//         },
//         {
//           title: "COPD Monitoring",
//           description: "Track disease progression and optimize treatment plans for COPD patients"
//         },
//         {
//           title: "Occupational Lung Disease",
//           description: "Assess workplace exposure effects and monitor lung health"
//         },
//         {
//           title: "Pre-Surgery Evaluation",
//           description: "Determine lung function before surgery to ensure safety"
//         }
//       ],
//       procedure: [
//         "Avoid using inhalers 4-6 hours before test (unless instructed)",
//         "You'll be seated comfortably and fitted with a mouthpiece",
//         "Follow breathing instructions carefully",
//         "Perform various breathing maneuvers as directed",
//         "Test may be repeated for accuracy",
//         "Bronchodilator may be given to test response"
//       ],
//       faqs: [
//         {
//           question: "Is the PFT test painful?",
//           answer: "No, PFT is completely painless and non-invasive. You'll simply breathe into a mouthpiece following our technician's instructions. Some people may feel slightly out of breath during certain maneuvers, but this is temporary and normal."
//         },
//         {
//           question: "Can I use my inhaler before the test?",
//           answer: "Please avoid using short-acting inhalers 4-6 hours before the test and long-acting inhalers 12 hours before. However, if you're having severe breathing difficulty, use your inhaler and inform us. We may need to reschedule."
//         },
//         {
//           question: "How should I prepare for PFT?",
//           answer: "Avoid heavy meals 2 hours before the test, wear loose comfortable clothing, and avoid smoking for at least 1 hour before. Take your regular medications unless specifically instructed otherwise by your doctor."
//         },
//         {
//           question: "Why do I need to repeat the breathing tests?",
//           answer: "We typically perform each maneuver 3 times to ensure accuracy and consistency. This helps us get the most reliable measurements of your lung function."
//         },
//         {
//           question: "When will I get my results?",
//           answer: "Results are typically available within 24 hours. Your doctor will receive a detailed report with interpretation and recommendations for your treatment plan."
//         }
//       ]
//     },
//     'ecg': {
//       title: "ECG (Electrocardiogram)",
//       category: "Cardiac Testing",
//       tagline: "Comprehensive Heart Monitoring",
//       heroImage: "https://images.unsplash.com/photo-1628595351029-c2bf17511435?w=1200&q=90",
//       icon: "❤️",
//       color: "#E63946",
//       duration: "10-15 minutes",
//       preparation: "No special preparation needed",
//       overview: "Non-invasive cardiac monitoring to detect arrhythmias, heart disease, and circulation issues. Our 12-lead ECG provides immediate results for accurate cardiac assessment, helping identify heart problems early and monitor treatment effectiveness.",
//       whatWeOffer: [
//         "12-lead ECG with latest technology",
//         "Immediate digital results",
//         "Arrhythmia detection and analysis",
//         "Heart health comprehensive assessment",
//         "Comparison with previous ECGs",
//         "Expert cardiologist review and interpretation"
//       ],
//       problemsSolved: [
//         {
//           title: "Heart Rhythm Disorders",
//           description: "Detect irregular heartbeats, atrial fibrillation, and other arrhythmias"
//         },
//         {
//           title: "Heart Attack Screening",
//           description: "Identify signs of past or ongoing heart attacks for immediate intervention"
//         },
//         {
//           title: "Heart Disease Monitoring",
//           description: "Track coronary artery disease, heart failure, and valve problems"
//         },
//         {
//           title: "Medication Effects",
//           description: "Monitor how heart medications are affecting your cardiac function"
//         }
//       ],
//       procedure: [
//         "Wear comfortable, loose-fitting clothing",
//         "Electrodes are placed on chest, arms, and legs",
//         "You'll lie still for a few minutes during recording",
//         "The test is completely painless",
//         "Results are available immediately",
//         "You can resume all normal activities right away"
//       ],
//       faqs: [
//         {
//           question: "Is an ECG test safe?",
//           answer: "Yes, ECG is completely safe and non-invasive. It only records your heart's electrical activity and doesn't send any electricity into your body. There are no risks or side effects."
//         },
//         {
//           question: "Do I need to prepare for an ECG?",
//           answer: "No special preparation is needed. Just avoid using oily or greasy lotions on your chest as they may interfere with electrode placement. Wear comfortable clothing that allows easy access to your chest."
//         },
//         {
//           question: "What can an ECG detect?",
//           answer: "An ECG can detect irregular heart rhythms, heart attacks (past or present), heart enlargement, inadequate blood or oxygen supply to the heart, and various other cardiac conditions."
//         },
//         {
//           question: "How long does an ECG take?",
//           answer: "The actual recording takes only about 5-10 minutes. With preparation and electrode placement, the entire process typically takes 10-15 minutes."
//         },
//         {
//           question: "Will I get results immediately?",
//           answer: "Yes, the ECG recording is available immediately. Our cardiologist will review it and provide a detailed interpretation report, usually within a few hours for routine cases."
//         }
//       ]
//     },
//     '2d-echo': {
//       title: "2D ECHO (Echocardiography)",
//       category: "Cardiac Imaging",
//       tagline: "Advanced Heart Imaging Technology",
//       heroImage: "https://images.unsplash.com/photo-1559757175-5700dde675bc?w=1200&q=90",
//       icon: "🫀",
//       color: "#1B4965",
//       duration: "30-45 minutes",
//       preparation: "No fasting required",
//       overview: "Sophisticated ultrasound imaging providing real-time visualization of heart structure, function, and blood flow patterns. Essential for evaluating heart valves, chambers, and overall cardiac performance with detailed Doppler studies and color flow mapping.",
//       whatWeOffer: [
//         "Real-time heart imaging with latest equipment",
//         "Valve function detailed assessment",
//         "Chamber size and wall motion analysis",
//         "Blood flow velocity evaluation",
//         "Doppler studies for comprehensive analysis",
//         "Color flow mapping for visualization"
//       ],
//       problemsSolved: [
//         {
//           title: "Valve Problems",
//           description: "Detect valve stenosis, regurgitation, and structural abnormalities"
//         },
//         {
//           title: "Heart Muscle Disease",
//           description: "Assess cardiomyopathy, heart failure, and muscle function"
//         },
//         {
//           title: "Congenital Defects",
//           description: "Identify birth defects and structural heart problems"
//         },
//         {
//           title: "Blood Clots",
//           description: "Detect blood clots in heart chambers and assess stroke risk"
//         }
//       ],
//       procedure: [
//         "No fasting required, eat normally before test",
//         "Lie on your left side on examination table",
//         "Gel is applied to chest for better ultrasound contact",
//         "Transducer is moved across chest to capture images",
//         "You may be asked to change positions",
//         "The test is painless and takes 30-45 minutes"
//       ],
//       faqs: [
//         {
//           question: "Is 2D Echo safe?",
//           answer: "Yes, echocardiography is completely safe. It uses sound waves (ultrasound) to create images, not radiation. There are no known risks or side effects. It's even safe during pregnancy."
//         },
//         {
//           question: "Do I need to fast before 2D Echo?",
//           answer: "No, fasting is not required for a standard 2D echo. You can eat and drink normally. However, for a transesophageal echo (TEE), fasting is required - we'll inform you if this type is needed."
//         },
//         {
//           question: "What's the difference between Echo and ECG?",
//           answer: "ECG records electrical activity of the heart, while Echo creates actual images of heart structure and function using ultrasound. Both are important but provide different information."
//         },
//         {
//           question: "Will the test hurt?",
//           answer: "No, the test is painless. You'll feel the transducer moving across your chest and may feel slight pressure, but there's no pain or discomfort. The gel may feel cool on your skin."
//         },
//         {
//           question: "How long before I get results?",
//           answer: "Preliminary findings are often discussed immediately after the test. A complete report with detailed analysis is typically ready within 24 hours and sent to your referring doctor."
//         }
//       ]
//     },
//     'allergy-testing': {
//       title: "Allergy Testing",
//       category: "Immunology",
//       tagline: "Comprehensive Allergen Identification",
//       heroImage: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=1200&q=90",
//       icon: "🤧",
//       color: "#FF9B6E",
//       duration: "45-60 minutes",
//       preparation: "Avoid antihistamines 3-5 days before",
//       overview: "Advanced allergy testing through skin prick tests and blood analysis to identify specific allergens causing your symptoms. Helps create personalized treatment and prevention plans for better allergy management and quality of life.",
//       whatWeOffer: [
//         "Skin prick testing for immediate allergies",
//         "IgE blood tests for comprehensive analysis",
//         "Food allergy panel testing",
//         "Environmental allergen identification",
//         "Drug allergy testing when needed",
//         "Detailed allergy report with recommendations"
//       ],
//       problemsSolved: [
//         {
//           title: "Seasonal Allergies",
//           description: "Identify pollen, grass, and mold allergies causing seasonal symptoms"
//         },
//         {
//           title: "Food Allergies",
//           description: "Pinpoint specific food allergies causing digestive or skin reactions"
//         },
//         {
//           title: "Skin Conditions",
//           description: "Find allergens causing eczema, hives, and other skin reactions"
//         },
//         {
//           title: "Asthma Triggers",
//           description: "Identify allergens that trigger or worsen asthma symptoms"
//         }
//       ],
//       procedure: [
//         "Stop antihistamines 3-5 days before test (consult doctor)",
//         "Small amounts of allergens applied to forearm or back",
//         "Wait 15-20 minutes for reactions to develop",
//         "Results are read and documented",
//         "Blood test may be done if needed",
//         "Detailed discussion of results and treatment plan"
//       ],
//       faqs: [
//         {
//           question: "Is allergy testing painful?",
//           answer: "Skin prick testing causes minimal discomfort - you'll feel a slight prick or scratch. Most people describe it as less painful than a vaccination. Blood testing is similar to a routine blood draw."
//         },
//         {
//           question: "Why should I stop taking antihistamines?",
//           answer: "Antihistamines can block allergic reactions and give false negative results. Stop them 3-5 days before testing (longer for some medications). Always consult your doctor before stopping any medication."
//         },
//         {
//           question: "Can children have allergy testing?",
//           answer: "Yes, children as young as 6 months can be tested. We use age-appropriate methods and our staff is trained in pediatric allergy testing to ensure comfort and accuracy."
//         },
//         {
//           question: "What if I have a severe reaction during testing?",
//           answer: "Testing is done under medical supervision with emergency equipment readily available. Reactions during testing are usually mild and limited to the test site. Severe reactions are extremely rare."
//         },
//         {
//           question: "How accurate is allergy testing?",
//           answer: "Skin prick testing is 85-90% accurate for most common allergens. Combined with your medical history and symptoms, it provides reliable identification of your specific allergies."
//         }
//       ]
//     },
//     'bronchoscopy': {
//       title: "Bronchoscopy",
//       category: "Interventional",
//       tagline: "Advanced Airway Visualization",
//       heroImage: "https://images.unsplash.com/photo-1582560475093-ba66accbc424?w=1200&q=90",
//       icon: "🔬",
//       color: "#2C5F7C",
//       duration: "30-60 minutes",
//       preparation: "Fasting 6 hours before procedure",
//       overview: "Minimally invasive procedure using a flexible bronchoscope to examine airways, collect samples, and perform therapeutic interventions. Performed under sedation for patient comfort, allowing detailed examination and treatment of respiratory conditions.",
//       whatWeOffer: [
//         "Flexible bronchoscopy with advanced equipment",
//         "Diagnostic and therapeutic procedures",
//         "Tissue biopsy for accurate diagnosis",
//         "Bronchoalveolar lavage (BAL)",
//         "Foreign body removal when needed",
//         "Conscious sedation for comfort"
//       ],
//       problemsSolved: [
//         {
//           title: "Persistent Cough",
//           description: "Investigate and treat chronic cough with unknown cause"
//         },
//         {
//           title: "Lung Infections",
//           description: "Collect samples to identify specific infections and guide treatment"
//         },
//         {
//           title: "Lung Cancer",
//           description: "Obtain tissue samples for cancer diagnosis and staging"
//         },
//         {
//           title: "Airway Obstruction",
//           description: "Remove foreign bodies and treat narrowed airways"
//         }
//       ],
//       procedure: [
//         "Fast for 6 hours before procedure",
//         "Local anesthetic applied to throat and nose",
//         "Sedative given for comfort and relaxation",
//         "Flexible bronchoscope inserted through nose or mouth",
//         "Airways examined and samples collected if needed",
//         "Recovery in observation area for 1-2 hours"
//       ],
//       faqs: [
//         {
//           question: "Is bronchoscopy painful?",
//           answer: "No, the procedure is performed under sedation and local anesthesia. You may feel slight pressure or urge to cough, but it shouldn't be painful. Most patients don't remember the procedure afterward."
//         },
//         {
//           question: "How should I prepare for bronchoscopy?",
//           answer: "Fast for at least 6 hours before the procedure. Inform your doctor about all medications, especially blood thinners. Arrange for someone to drive you home as you'll be sedated."
//         },
//         {
//           question: "What are the risks of bronchoscopy?",
//           answer: "Bronchoscopy is very safe. Rare complications may include minor bleeding, reaction to sedation, or temporary breathing difficulty. Our experienced team minimizes these risks."
//         },
//         {
//           question: "How long is the recovery?",
//           answer: "Most people recover quickly. You'll be monitored for 1-2 hours after the procedure. Avoid eating or drinking for 2 hours. Some throat soreness or cough is normal for 1-2 days."
//         },
//         {
//           question: "When will I get biopsy results?",
//           answer: "Initial findings are available immediately. Biopsy results typically take 3-7 days as they require laboratory analysis. Your doctor will discuss results and treatment plan with you."
//         }
//       ]
//     },
//     'thoracoscopy': {
//       title: "Thoracoscopy",
//       category: "Surgical",
//       tagline: "Minimally Invasive Chest Surgery",
//       heroImage: "https://images.unsplash.com/photo-1579154204601-01588f351e67?w=1200&q=90",
//       icon: "🏥",
//       color: "#62B6CB",
//       duration: "1-2 hours",
//       preparation: "Pre-operative evaluation required",
//       overview: "Advanced minimally invasive surgical procedure for diagnosis and treatment of chest conditions. Uses small incisions and a camera for better visualization and faster recovery compared to traditional surgery.",
//       whatWeOffer: [
//         "Video-assisted thoracic surgery (VATS)",
//         "Minimal scarring with small incisions",
//         "Faster recovery than open surgery",
//         "Pleural biopsy for diagnosis",
//         "Fluid drainage and pleurodesis",
//         "Expert surgical team with experience"
//       ],
//       problemsSolved: [
//         {
//           title: "Pleural Effusion",
//           description: "Diagnose and treat fluid accumulation around lungs"
//         },
//         {
//           title: "Lung Nodules",
//           description: "Remove suspicious lung nodules for diagnosis"
//         },
//         {
//           title: "Pneumothorax",
//           description: "Treat collapsed lung and prevent recurrence"
//         },
//         {
//           title: "Pleural Disease",
//           description: "Diagnose and treat various pleural conditions"
//         }
//       ],
//       procedure: [
//         "Pre-operative evaluation and tests",
//         "General anesthesia administered",
//         "Small incisions (1-2 cm) made in chest wall",
//         "Camera and instruments inserted",
//         "Surgical procedure performed",
//         "Hospital stay typically 1-3 days"
//       ],
//       faqs: [
//         {
//           question: "Is thoracoscopy better than open surgery?",
//           answer: "Yes, in most cases. Thoracoscopy offers less pain, smaller scars, faster recovery, and shorter hospital stay compared to open surgery, while providing excellent visualization and results."
//         },
//         {
//           question: "How long is the recovery period?",
//           answer: "Most patients return to light activities within 1-2 weeks and full activities within 4-6 weeks. Recovery is much faster than traditional open chest surgery which can take 2-3 months."
//         },
//         {
//           question: "Will I have chest tubes after surgery?",
//           answer: "Usually yes, a chest tube is placed during surgery to drain fluid and air. It typically stays for 1-3 days and is removed before hospital discharge once drainage is minimal."
//         },
//         {
//           question: "What are the risks of thoracoscopy?",
//           answer: "While generally safe, risks include bleeding, infection, air leak, and rarely, need for conversion to open surgery. Our experienced surgical team minimizes these risks with careful technique."
//         },
//         {
//           question: "How long will I stay in hospital?",
//           answer: "Most thoracoscopy patients stay 1-3 days depending on the procedure and recovery. Some simple procedures may allow same-day or next-day discharge."
//         }
//       ]
//     }
//   };

//   const service = servicesData[serviceId];

//   if (!service) {
//     return (
//       <div style={{padding: '4rem 2rem', textAlign: 'center'}}>
//         <h2>Service not found</h2>
//         <Link to="/" style={{color: '#E86A33'}}>Back to Home</Link>
//       </div>
//     );
//   }

//   const toggleFAQ = (index) => {
//     setOpenFAQ(openFAQ === index ? null : index);
//   };

//   return (
//     <>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700;800&family=Inter:wght@300;400;500;600;700;800&display=swap');
        
//         * {
//           margin: 0;
//           padding: 0;
//           box-sizing: border-box;
//         }

//         body {
//           font-family: 'Inter', sans-serif;
//           color: #1a1a1a;
//         }

//         .service-detail-page {
//           width: 100%;
//           min-height: 100vh;
//           background: linear-gradient(135deg, #F8FAFB 0%, white 100%);
//         }

//         /* Hero Section */
//         .service-hero {
//           position: relative;
//           height: 70vh;
//           min-height: 500px;
//           background-size: cover;
//           background-position: center;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           overflow: hidden;
//         }

//         .service-hero::before {
//           content: '';
//           position: absolute;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background: linear-gradient(135deg, rgba(27, 73, 101, 0.9) 0%, rgba(44, 95, 124, 0.85) 100%);
//         }

//         .service-hero-content {
//           position: relative;
//           z-index: 2;
//           text-align: center;
//           color: white;
//           max-width: 1000px;
//           padding: 2rem;
//         }

//         .back-link {
//           display: inline-flex;
//           align-items: center;
//           gap: 0.5rem;
//           color: white;
//           text-decoration: none;
//           font-weight: 600;
//           margin-bottom: 2rem;
//           padding: 0.8rem 1.5rem;
//           background: rgba(255, 255, 255, 0.1);
//           backdrop-filter: blur(10px);
//           border-radius: 50px;
//           border: 1px solid rgba(255, 255, 255, 0.2);
//           transition: all 0.3s ease;
//         }

//         .back-link:hover {
//           background: rgba(255, 255, 255, 0.2);
//           transform: translateX(-5px);
//         }

//         .service-icon-large {
//           font-size: 5rem;
//           margin-bottom: 1rem;
//           animation: float 3s ease-in-out infinite;
//         }

//         @keyframes float {
//           0%, 100% { transform: translateY(0); }
//           50% { transform: translateY(-10px); }
//         }

//         .service-category-badge {
//           display: inline-block;
//           padding: 0.5rem 1.5rem;
//           background: rgba(255, 155, 110, 0.2);
//           border: 1px solid rgba(255, 155, 110, 0.4);
//           border-radius: 50px;
//           color: #FFD700;
//           font-size: 0.9rem;
//           font-weight: 700;
//           letter-spacing: 2px;
//           text-transform: uppercase;
//           margin-bottom: 1.5rem;
//         }

//         .service-detail-title {
//           font-family: 'Playfair Display', serif;
//           font-size: 4rem;
//           font-weight: 800;
//           margin-bottom: 1rem;
//           line-height: 1.1;
//         }

//         .service-tagline {
//           font-size: 1.5rem;
//           font-weight: 300;
//           opacity: 0.95;
//           margin-bottom: 2rem;
//         }

//         .service-meta {
//           display: flex;
//           gap: 3rem;
//           justify-content: center;
//           flex-wrap: wrap;
//         }

//         .meta-item {
//           display: flex;
//           align-items: center;
//           gap: 0.7rem;
//           font-size: 1.1rem;
//         }

//         /* Quick Contact Bar */
//         .quick-contact-bar {
//           position: sticky;
//           top: 0;
//           z-index: 999;
//           background: white;
//           box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
//           padding: 1.5rem 2rem;
//           margin-top: -50px;
//           margin-bottom: 2rem;
//         }

//         .quick-contact-content {
//           max-width: 1400px;
//           margin: 0 auto;
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           gap: 2rem;
//           flex-wrap: wrap;
//         }

//         .contact-info-compact {
//           display: flex;
//           gap: 2rem;
//           flex-wrap: wrap;
//         }

//         .contact-item-compact {
//           display: flex;
//           align-items: center;
//           gap: 0.7rem;
//           font-size: 0.95rem;
//           color: #1B4965;
//           font-weight: 600;
//         }

//         .contact-item-compact a {
//           color: #1B4965;
//           text-decoration: none;
//           transition: color 0.3s ease;
//         }

//         .contact-item-compact a:hover {
//           color: #E86A33;
//         }

//         .book-button {
//           padding: 1rem 2.5rem;
//           background: linear-gradient(135deg, #E86A33, #FF9B6E);
//           color: white;
//           border: none;
//           border-radius: 50px;
//           font-weight: 700;
//           font-size: 1rem;
//           cursor: pointer;
//           display: flex;
//           align-items: center;
//           gap: 0.7rem;
//           transition: all 0.3s ease;
//           box-shadow: 0 4px 15px rgba(232, 106, 51, 0.3);
//           text-decoration: none;
//         }

//         .book-button:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 6px 25px rgba(232, 106, 51, 0.4);
//         }

//         /* Main Content */
//         .service-content {
//           max-width: 1400px;
//           margin: 0 auto;
//           padding: 4rem 2rem;
//         }

//         .content-grid {
//           display: grid;
//           grid-template-columns: 2fr 1fr;
//           gap: 4rem;
//           align-items: start;
//         }

//         /* Sections */
//         .content-section {
//           background: white;
//           border-radius: 25px;
//           padding: 3rem;
//           box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
//           margin-bottom: 2rem;
//         }

//         .section-title {
//           font-family: 'Playfair Display', serif;
//           font-size: 2.5rem;
//           font-weight: 800;
//           color: #1B4965;
//           margin-bottom: 1.5rem;
//           display: flex;
//           align-items: center;
//           gap: 1rem;
//         }

//         .section-subtitle {
//           font-size: 1.5rem;
//           font-weight: 700;
//           color: #1B4965;
//           margin: 2rem 0 1rem;
//         }

//         .section-text {
//           font-size: 1.1rem;
//           line-height: 1.9;
//           color: #666;
//           margin-bottom: 2rem;
//         }

//         .feature-list {
//           display: grid;
//           gap: 1rem;
//         }

//         .feature-list-item {
//           display: flex;
//           align-items: flex-start;
//           gap: 1rem;
//           padding: 1rem;
//           background: #F8FAFB;
//           border-radius: 12px;
//           transition: all 0.3s ease;
//         }

//         .feature-list-item:hover {
//           background: #fff;
//           box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
//           transform: translateX(5px);
//         }

//         .feature-icon {
//           color: #E86A33;
//           flex-shrink: 0;
//           margin-top: 0.2rem;
//         }

//         .feature-text {
//           font-size: 1.05rem;
//           line-height: 1.7;
//           color: #1a1a1a;
//         }

//         /* Problems Solved */
//         .problems-grid {
//           display: grid;
//           grid-template-columns: repeat(2, 1fr);
//           gap: 1.5rem;
//           margin-top: 2rem;
//         }

//         .problem-card {
//           padding: 2rem;
//           background: linear-gradient(135deg, #F8FAFB 0%, white 100%);
//           border-radius: 20px;
//           border-left: 4px solid #E86A33;
//           transition: all 0.3s ease;
//         }

//         .problem-card:hover {
//           transform: translateY(-5px);
//           box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
//         }

//         .problem-title {
//           font-size: 1.3rem;
//           font-weight: 700;
//           color: #1B4965;
//           margin-bottom: 0.8rem;
//           display: flex;
//           align-items: center;
//           gap: 0.7rem;
//         }

//         .problem-description {
//           font-size: 1rem;
//           line-height: 1.7;
//           color: #666;
//         }

//         /* Procedure Steps */
//         .procedure-steps {
//           counter-reset: step-counter;
//           display: flex;
//           flex-direction: column;
//           gap: 1.5rem;
//           margin-top: 2rem;
//         }

//         .procedure-step {
//           position: relative;
//           padding-left: 5rem;
//           padding: 1.5rem 1.5rem 1.5rem 5rem;
//           background: #F8FAFB;
//           border-radius: 15px;
//           transition: all 0.3s ease;
//         }

//         .procedure-step:hover {
//           background: white;
//           box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
//         }

//         .procedure-step::before {
//           counter-increment: step-counter;
//           content: counter(step-counter);
//           position: absolute;
//           left: 1.5rem;
//           top: 50%;
//           transform: translateY(-50%);
//           width: 45px;
//           height: 45px;
//           background: linear-gradient(135deg, #E86A33, #FF9B6E);
//           color: white;
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-weight: 800;
//           font-size: 1.3rem;
//           font-family: 'Playfair Display', serif;
//         }

//         /* FAQ Section */
//         .faq-list {
//           display: flex;
//           flex-direction: column;
//           gap: 1rem;
//         }

//         .faq-item {
//           background: white;
//           border: 2px solid #f0f0f0;
//           border-radius: 15px;
//           overflow: hidden;
//           transition: all 0.3s ease;
//         }

//         .faq-item.open {
//           border-color: #E86A33;
//           box-shadow: 0 5px 20px rgba(232, 106, 51, 0.1);
//         }

//         .faq-question {
//           padding: 1.5rem 2rem;
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           cursor: pointer;
//           font-weight: 700;
//           font-size: 1.1rem;
//           color: #1B4965;
//           transition: all 0.3s ease;
//         }

//         .faq-question:hover {
//           color: #E86A33;
//         }

//         .faq-answer {
//           padding: 0 2rem 1.5rem;
//           font-size: 1.05rem;
//           line-height: 1.8;
//           color: #666;
//           animation: slideDown 0.3s ease;
//         }

//         @keyframes slideDown {
//           from {
//             opacity: 0;
//             transform: translateY(-10px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         /* Sidebar */
//         .sidebar {
//           position: sticky;
//           top: 200px;
//         }

//         .sidebar-card {
//           background: white;
//           border-radius: 25px;
//           padding: 2.5rem;
//           box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
//           margin-bottom: 2rem;
//         }

//         .sidebar-title {
//           font-size: 1.5rem;
//           font-weight: 700;
//           color: #1B4965;
//           margin-bottom: 1.5rem;
//           font-family: 'Playfair Display', serif;
//         }

//         .info-item {
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           padding: 1rem 0;
//           border-bottom: 1px solid #f0f0f0;
//         }

//         .info-item:last-child {
//           border-bottom: none;
//         }

//         .info-label {
//           font-weight: 600;
//           color: #666;
//           font-size: 0.95rem;
//         }

//         .info-value {
//           font-weight: 700;
//           color: #1B4965;
//           font-size: 1rem;
//         }

//         .cta-card {
//           background: linear-gradient(135deg, #1B4965 0%, #2C5F7C 100%);
//           color: white;
//           text-align: center;
//         }

//         .cta-card-title {
//           font-size: 1.8rem;
//           font-weight: 800;
//           margin-bottom: 1rem;
//           font-family: 'Playfair Display', serif;
//         }

//         .cta-card-text {
//           font-size: 1rem;
//           opacity: 0.95;
//           margin-bottom: 1.5rem;
//           line-height: 1.7;
//         }

//         .cta-contact-list {
//           display: flex;
//           flex-direction: column;
//           gap: 1rem;
//           margin: 2rem 0;
//         }

//         .cta-contact-item {
//           display: flex;
//           align-items: center;
//           gap: 1rem;
//           padding: 1rem;
//           background: rgba(255, 255, 255, 0.1);
//           border-radius: 12px;
//           font-weight: 600;
//         }

//         .cta-contact-item a {
//           color: white;
//           text-decoration: none;
//         }

//         .features-badge-list {
//           display: flex;
//           flex-wrap: wrap;
//           gap: 0.8rem;
//           margin-top: 1rem;
//         }

//         .feature-badge {
//           padding: 0.6rem 1.2rem;
//           background: #F8FAFB;
//           border-radius: 50px;
//           font-size: 0.9rem;
//           font-weight: 600;
//           color: #1B4965;
//           display: flex;
//           align-items: center;
//           gap: 0.5rem;
//         }

//         /* Responsive */
//         @media (max-width: 1024px) {
//           .content-grid {
//             grid-template-columns: 1fr;
//           }

//           .sidebar {
//             position: relative;
//             top: 0;
//           }

//           .problems-grid {
//             grid-template-columns: 1fr;
//           }
//         }

//         @media (max-width: 768px) {
//           .service-detail-title {
//             font-size: 2.5rem;
//           }

//           .service-tagline {
//             font-size: 1.2rem;
//           }

//           .service-meta {
//             flex-direction: column;
//             gap: 1rem;
//           }

//           .quick-contact-content {
//             flex-direction: column;
//             align-items: flex-start;
//           }

//           .content-section {
//             padding: 2rem;
//           }

//           .section-title {
//             font-size: 2rem;
//           }

//           .procedure-step {
//             padding-left: 4rem;
//           }

//           .procedure-step::before {
//             width: 35px;
//             height: 35px;
//             font-size: 1.1rem;
//             left: 1rem;
//           }
//         }
//       `}</style>

//       <div className="service-detail-page">
//         {/* Hero Section */}
//         <section 
//           className="service-hero"
//           style={{backgroundImage: `url(${service.heroImage})`}}
//         >
//           <div className="service-hero-content">
//             <Link to="/" className="back-link">
//               <ArrowLeft size={20} />
//               Back to Home
//             </Link>
            
//             <div className="service-icon-large">{service.icon}</div>
//             <div className="service-category-badge">{service.category}</div>
//             <h1 className="service-detail-title">{service.title}</h1>
//             <p className="service-tagline">{service.tagline}</p>
            
//             <div className="service-meta">
//               <div className="meta-item">
//                 <Clock size={20} />
//                 <span>{service.duration}</span>
//               </div>
//               <div className="meta-item">
//                 <AlertCircle size={20} />
//                 <span>{service.preparation}</span>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* Quick Contact Bar */}
//         <div className="quick-contact-bar">
//           <div className="quick-contact-content">
//             <div className="contact-info-compact">
//               {/* <div className="contact-item-compact">
//                 <Phone size={18} />
//                 <a href="tel:+911234567890">+91 123 456 7890</a>
//               </div> */}
//               <div className="contact-item-compact">
//                 <Phone size={18} />
//                 <a href="tel:+919989162222">+91 99891 62222</a>
//               </div>
//               <div className="contact-item-compact">
//                 <Mail size={18} />
//                 <a href="mailto:vayulungcare@gmail.com">vayulungcare@gmail.com</a>
//               </div>
//             </div>
//             <a href="#book-appointment" className="book-button">
//               <Calendar size={20} />
//               Book Appointment
//             </a>
//           </div>
//         </div>

//         {/* Main Content */}
//         <div className="service-content">
//           <div className="content-grid">
//             {/* Main Column */}
//             <div>
//               {/* Overview */}
//               <div className="content-section">
//                 <h2 className="section-title">
//                   <Info size={32} />
//                   Overview
//                 </h2>
//                 <p className="section-text">{service.overview}</p>
//               </div>

//               {/* What We Offer */}
//               <div className="content-section">
//                 <h2 className="section-title">
//                   <Shield size={32} />
//                   What We Offer
//                 </h2>
//                 <div className="feature-list">
//                   {service.whatWeOffer.map((item, index) => (
//                     <div key={index} className="feature-list-item">
//                       <CheckCircle size={22} className="feature-icon" />
//                       <span className="feature-text">{item}</span>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               {/* Problems Solved */}
//               <div className="content-section">
//                 <h2 className="section-title">
//                   <Heart size={32} />
//                   Problems We Solve
//                 </h2>
//                 <div className="problems-grid">
//                   {service.problemsSolved.map((problem, index) => (
//                     <div key={index} className="problem-card">
//                       <h3 className="problem-title">
//                         <CheckCircle size={20} />
//                         {problem.title}
//                       </h3>
//                       <p className="problem-description">{problem.description}</p>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               {/* Procedure */}
//               <div className="content-section">
//                 <h2 className="section-title">
//                   <Award size={32} />
//                   What to Expect
//                 </h2>
//                 <div className="procedure-steps">
//                   {service.procedure.map((step, index) => (
//                     <div key={index} className="procedure-step">
//                       {step}
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               {/* FAQs */}
//               <div className="content-section">
//                 <h2 className="section-title">
//                   <AlertCircle size={32} />
//                   Frequently Asked Questions
//                 </h2>
//                 <div className="faq-list">
//                   {service.faqs.map((faq, index) => (
//                     <div 
//                       key={index} 
//                       className={`faq-item ${openFAQ === index ? 'open' : ''}`}
//                     >
//                       <div 
//                         className="faq-question"
//                         onClick={() => toggleFAQ(index)}
//                       >
//                         <span>{faq.question}</span>
//                         {openFAQ === index ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
//                       </div>
//                       {openFAQ === index && (
//                         <div className="faq-answer">
//                           {faq.answer}
//                         </div>
//                       )}
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>

//             {/* Sidebar */}
//             <div className="sidebar">
//               {/* Quick Info */}
//               <div className="sidebar-card">
//                 <h3 className="sidebar-title">Quick Information</h3>
//                 <div className="info-item">
//                   <span className="info-label">Duration</span>
//                   <span className="info-value">{service.duration}</span>
//                 </div>
//                 <div className="info-item">
//                   <span className="info-label">Category</span>
//                   <span className="info-value">{service.category}</span>
//                 </div>
//                 <div className="info-item">
//                   <span className="info-label">Preparation</span>
//                   <span className="info-value">{service.preparation}</span>
//                 </div>
//               </div>

//               {/* CTA Card */}
//               <div className="sidebar-card cta-card" id="book-appointment">
//                 <h3 className="cta-card-title">Ready to Book?</h3>
//                 <p className="cta-card-text">
//                   Schedule your appointment today and take the first step towards better health
//                 </p>
                
//                 <div className="cta-contact-list">
//                   {/* <div className="cta-contact-item">
//                     <Phone size={20} />
//                     <a href="tel:+911234567890">+91 123 456 7890</a>
//                   </div> */}
//                   <div className="cta-contact-item">
//                     <Phone size={20} />
//                     <a href="tel:+919989162222"> +91 99891 62222 </a>
//                   </div>
//                   <div className="cta-contact-item">
//                     <Mail size={20} />
//                     <a href="mailto:vayulungcare@gmail.com">vayulungcare@gmail.com</a>
//                   </div>
//                 </div>

//                 <button className="book-button" style={{width: '100%', justifyContent: 'center'}}>
//                   <Calendar size={20} />
//                   Book Now
//                 </button>
//               </div>

//               {/* Other Services */}
//               <div className="sidebar-card">
//                 <h3 className="sidebar-title">Other Services</h3>
//                 <div className="features-badge-list">
//                   {Object.keys(servicesData)
//                     .filter(key => key !== serviceId)
//                     .slice(0, 6)
//                     .map((key) => (
//                       <Link 
//                         key={key}
//                         to={`/services/${key}`}
//                         className="feature-badge"
//                         style={{textDecoration: 'none'}}
//                       >
//                         {servicesData[key].icon}
//                         {servicesData[key].title}
//                       </Link>
//                     ))}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ServiceDetailPage;




// import React, { useState } from 'react';
// import { useParams, Link } from 'react-router-dom';
// import { 
//   ArrowLeft,
//   CheckCircle,
//   Clock,
//   Phone,
//   Mail,
//   Calendar,
//   ChevronDown,
//   ChevronUp,
//   Award,
//   Shield,
//   Users,
//   AlertCircle,
//   Info,
//   Heart
// } from 'lucide-react';

// const ServiceDetailPage = () => {
//   const { serviceId } = useParams();
//   const [openFAQ, setOpenFAQ] = useState(null);

//   // Service data with complete details
//   // const servicesData = {
//   //   'chest-xray': {
//   //     title: "Chest X-Ray",
//   //     category: "Diagnostic Imaging",
//   //     tagline: "Advanced Digital Radiography for Accurate Diagnosis",
//   //     heroImage: "https://images.unsplash.com/photo-1530497610245-94d3c16cda28?w=1200&q=90",
//   //     icon: "🔬",
//   //     color: "#E86A33",
//   //     duration: "15-20 minutes",
//   //     preparation: "No special preparation required",
//   //     overview: "Our state-of-the-art digital X-ray technology provides comprehensive chest imaging for accurate diagnosis of respiratory conditions, lung infections, and structural abnormalities. With minimal radiation exposure and immediate results, we ensure quick and reliable diagnostic services.",
//   //     whatWeOffer: [
//   //       "High-resolution digital X-ray imaging",
//   //       "Same-day results with expert radiologist reports",
//   //       "Low radiation exposure technology",
//   //       "Portable X-ray services available",
//   //       "Comparison with previous images",
//   //       "Digital archiving for easy access"
//   //     ],
//   //     problemsSolved: [
//   //       {
//   //         title: "Respiratory Infections",
//   //         description: "Detect pneumonia, tuberculosis, and other lung infections early for prompt treatment"
//   //       },
//   //       {
//   //         title: "Lung Conditions",
//   //         description: "Identify COPD, emphysema, bronchitis, and other chronic lung diseases"
//   //       },
//   //       {
//   //         title: "Heart Issues",
//   //         description: "Assess heart size, shape, and detect fluid around the heart"
//   //       },
//   //       {
//   //         title: "Bone Problems",
//   //         description: "Detect rib fractures, spine abnormalities, and chest wall issues"
//   //       }
//   //     ],
//   //     procedure: [
//   //       "You'll be asked to remove jewelry and metal objects",
//   //       "Stand or sit in front of the X-ray machine",
//   //       "Follow breathing instructions from the technician",
//   //       "Images are captured in just a few seconds",
//   //       "You can resume normal activities immediately"
//   //     ],
//   //     faqs: [
//   //       {
//   //         question: "Is chest X-ray safe?",
//   //         answer: "Yes, chest X-rays are very safe. The amount of radiation exposure is minimal and the benefits of accurate diagnosis far outweigh the risks. Our modern equipment uses the lowest possible radiation doses."
//   //       },
//   //       {
//   //         question: "Do I need to prepare for a chest X-ray?",
//   //         answer: "No special preparation is needed. You can eat and drink normally. Just wear comfortable clothing and remove any jewelry or metal objects from your chest area."
//   //       },
//   //       {
//   //         question: "How long does it take to get results?",
//   //         answer: "Digital X-ray results are available within a few hours. Our radiologist will review the images and provide a detailed report the same day. Urgent cases are prioritized."
//   //       },
//   //       {
//   //         question: "Can pregnant women have chest X-rays?",
//   //         answer: "We generally avoid X-rays during pregnancy unless absolutely necessary. Please inform us if you are or might be pregnant, and we'll discuss safer alternatives with your doctor."
//   //       },
//   //       {
//   //         question: "How often can I have a chest X-ray?",
//   //         answer: "The frequency depends on your medical condition. Your doctor will determine the appropriate timing. Modern equipment uses very low radiation, making it safe for regular monitoring when medically necessary."
//   //       }
//   //     ]
//   //   }
//   //   // Add other services as needed
//   // };
//    const servicesData = {
//     'chest-xray': {
//       title: "Chest X-Ray",
//       category: "Diagnostic Imaging",
//       tagline: "Advanced Digital Radiography for Accurate Diagnosis",
//       heroImage: "https://images.unsplash.com/photo-1530497610245-94d3c16cda28?w=1200&q=90",
//       icon: "🔬",
//       color: "#E86A33",
//       duration: "15-20 minutes",
//       preparation: "No special preparation required",
//       overview: "Our state-of-the-art digital X-ray technology provides comprehensive chest imaging for accurate diagnosis of respiratory conditions, lung infections, and structural abnormalities. With minimal radiation exposure and immediate results, we ensure quick and reliable diagnostic services.",
//       whatWeOffer: [
//         "High-resolution digital X-ray imaging",
//         "Same-day results with expert radiologist reports",
//         "Low radiation exposure technology",
//         "Portable X-ray services available",
//         "Comparison with previous images",
//         "Digital archiving for easy access"
//       ],
//       problemsSolved: [
//         {
//           title: "Respiratory Infections",
//           description: "Detect pneumonia, tuberculosis, and other lung infections early for prompt treatment"
//         },
//         {
//           title: "Lung Conditions",
//           description: "Identify COPD, emphysema, bronchitis, and other chronic lung diseases"
//         },
//         {
//           title: "Heart Issues",
//           description: "Assess heart size, shape, and detect fluid around the heart"
//         },
//         {
//           title: "Bone Problems",
//           description: "Detect rib fractures, spine abnormalities, and chest wall issues"
//         }
//       ],
//       procedure: [
//         "You'll be asked to remove jewelry and metal objects",
//         "Stand or sit in front of the X-ray machine",
//         "Follow breathing instructions from the technician",
//         "Images are captured in just a few seconds",
//         "You can resume normal activities immediately"
//       ],
//       faqs: [
//         {
//           question: "Is chest X-ray safe?",
//           answer: "Yes, chest X-rays are very safe. The amount of radiation exposure is minimal and the benefits of accurate diagnosis far outweigh the risks. Our modern equipment uses the lowest possible radiation doses."
//         },
//         {
//           question: "Do I need to prepare for a chest X-ray?",
//           answer: "No special preparation is needed. You can eat and drink normally. Just wear comfortable clothing and remove any jewelry or metal objects from your chest area."
//         },
//         {
//           question: "How long does it take to get results?",
//           answer: "Digital X-ray results are available within a few hours. Our radiologist will review the images and provide a detailed report the same day. Urgent cases are prioritized."
//         },
//         {
//           question: "Can pregnant women have chest X-rays?",
//           answer: "We generally avoid X-rays during pregnancy unless absolutely necessary. Please inform us if you are or might be pregnant, and we'll discuss safer alternatives with your doctor."
//         },
//         {
//           question: "How often can I have a chest X-ray?",
//           answer: "The frequency depends on your medical condition. Your doctor will determine the appropriate timing. Modern equipment uses very low radiation, making it safe for regular monitoring when medically necessary."
//         }
//       ]
//     },
//     'pft': {
//       title: "PFT (Pulmonary Function Test)",
//       category: "Respiratory Testing",
//       tagline: "Comprehensive Lung Function Evaluation",
//       heroImage: "https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=1200&q=90",
//       icon: "🫁",
//       color: "#2C85B8",
//       duration: "30-45 minutes",
//       preparation: "Avoid heavy meals 2 hours before test",
//       overview: "Complete pulmonary function testing to measure lung capacity, airflow rates, and gas exchange efficiency. Essential for diagnosing and monitoring respiratory conditions like asthma, COPD, and interstitial lung diseases. Our comprehensive testing provides detailed insights into your lung health.",
//       whatWeOffer: [
//         "Spirometry testing with advanced equipment",
//         "Lung volume measurement",
//         "Diffusion capacity testing (DLCO)",
//         "Exercise testing for respiratory assessment",
//         "Pre and post-bronchodilator testing",
//         "Detailed analysis reports with interpretation"
//       ],
//       problemsSolved: [
//         {
//           title: "Asthma Management",
//           description: "Accurately diagnose asthma severity and monitor treatment effectiveness"
//         },
//         {
//           title: "COPD Monitoring",
//           description: "Track disease progression and optimize treatment plans for COPD patients"
//         },
//         {
//           title: "Occupational Lung Disease",
//           description: "Assess workplace exposure effects and monitor lung health"
//         },
//         {
//           title: "Pre-Surgery Evaluation",
//           description: "Determine lung function before surgery to ensure safety"
//         }
//       ],
//       procedure: [
//         "Avoid using inhalers 4-6 hours before test (unless instructed)",
//         "You'll be seated comfortably and fitted with a mouthpiece",
//         "Follow breathing instructions carefully",
//         "Perform various breathing maneuvers as directed",
//         "Test may be repeated for accuracy",
//         "Bronchodilator may be given to test response"
//       ],
//       faqs: [
//         {
//           question: "Is the PFT test painful?",
//           answer: "No, PFT is completely painless and non-invasive. You'll simply breathe into a mouthpiece following our technician's instructions. Some people may feel slightly out of breath during certain maneuvers, but this is temporary and normal."
//         },
//         {
//           question: "Can I use my inhaler before the test?",
//           answer: "Please avoid using short-acting inhalers 4-6 hours before the test and long-acting inhalers 12 hours before. However, if you're having severe breathing difficulty, use your inhaler and inform us. We may need to reschedule."
//         },
//         {
//           question: "How should I prepare for PFT?",
//           answer: "Avoid heavy meals 2 hours before the test, wear loose comfortable clothing, and avoid smoking for at least 1 hour before. Take your regular medications unless specifically instructed otherwise by your doctor."
//         },
//         {
//           question: "Why do I need to repeat the breathing tests?",
//           answer: "We typically perform each maneuver 3 times to ensure accuracy and consistency. This helps us get the most reliable measurements of your lung function."
//         },
//         {
//           question: "When will I get my results?",
//           answer: "Results are typically available within 24 hours. Your doctor will receive a detailed report with interpretation and recommendations for your treatment plan."
//         }
//       ]
//     },
//     'ecg': {
//       title: "ECG (Electrocardiogram)",
//       category: "Cardiac Testing",
//       tagline: "Comprehensive Heart Monitoring",
//       heroImage: "https://images.unsplash.com/photo-1628595351029-c2bf17511435?w=1200&q=90",
//       icon: "❤️",
//       color: "#E63946",
//       duration: "10-15 minutes",
//       preparation: "No special preparation needed",
//       overview: "Non-invasive cardiac monitoring to detect arrhythmias, heart disease, and circulation issues. Our 12-lead ECG provides immediate results for accurate cardiac assessment, helping identify heart problems early and monitor treatment effectiveness.",
//       whatWeOffer: [
//         "12-lead ECG with latest technology",
//         "Immediate digital results",
//         "Arrhythmia detection and analysis",
//         "Heart health comprehensive assessment",
//         "Comparison with previous ECGs",
//         "Expert cardiologist review and interpretation"
//       ],
//       problemsSolved: [
//         {
//           title: "Heart Rhythm Disorders",
//           description: "Detect irregular heartbeats, atrial fibrillation, and other arrhythmias"
//         },
//         {
//           title: "Heart Attack Screening",
//           description: "Identify signs of past or ongoing heart attacks for immediate intervention"
//         },
//         {
//           title: "Heart Disease Monitoring",
//           description: "Track coronary artery disease, heart failure, and valve problems"
//         },
//         {
//           title: "Medication Effects",
//           description: "Monitor how heart medications are affecting your cardiac function"
//         }
//       ],
//       procedure: [
//         "Wear comfortable, loose-fitting clothing",
//         "Electrodes are placed on chest, arms, and legs",
//         "You'll lie still for a few minutes during recording",
//         "The test is completely painless",
//         "Results are available immediately",
//         "You can resume all normal activities right away"
//       ],
//       faqs: [
//         {
//           question: "Is an ECG test safe?",
//           answer: "Yes, ECG is completely safe and non-invasive. It only records your heart's electrical activity and doesn't send any electricity into your body. There are no risks or side effects."
//         },
//         {
//           question: "Do I need to prepare for an ECG?",
//           answer: "No special preparation is needed. Just avoid using oily or greasy lotions on your chest as they may interfere with electrode placement. Wear comfortable clothing that allows easy access to your chest."
//         },
//         {
//           question: "What can an ECG detect?",
//           answer: "An ECG can detect irregular heart rhythms, heart attacks (past or present), heart enlargement, inadequate blood or oxygen supply to the heart, and various other cardiac conditions."
//         },
//         {
//           question: "How long does an ECG take?",
//           answer: "The actual recording takes only about 5-10 minutes. With preparation and electrode placement, the entire process typically takes 10-15 minutes."
//         },
//         {
//           question: "Will I get results immediately?",
//           answer: "Yes, the ECG recording is available immediately. Our cardiologist will review it and provide a detailed interpretation report, usually within a few hours for routine cases."
//         }
//       ]
//     },
//     '2d-echo': {
//       title: "2D ECHO (Echocardiography)",
//       category: "Cardiac Imaging",
//       tagline: "Advanced Heart Imaging Technology",
//       heroImage: "https://images.unsplash.com/photo-1559757175-5700dde675bc?w=1200&q=90",
//       icon: "🫀",
//       color: "#1B4965",
//       duration: "30-45 minutes",
//       preparation: "No fasting required",
//       overview: "Sophisticated ultrasound imaging providing real-time visualization of heart structure, function, and blood flow patterns. Essential for evaluating heart valves, chambers, and overall cardiac performance with detailed Doppler studies and color flow mapping.",
//       whatWeOffer: [
//         "Real-time heart imaging with latest equipment",
//         "Valve function detailed assessment",
//         "Chamber size and wall motion analysis",
//         "Blood flow velocity evaluation",
//         "Doppler studies for comprehensive analysis",
//         "Color flow mapping for visualization"
//       ],
//       problemsSolved: [
//         {
//           title: "Valve Problems",
//           description: "Detect valve stenosis, regurgitation, and structural abnormalities"
//         },
//         {
//           title: "Heart Muscle Disease",
//           description: "Assess cardiomyopathy, heart failure, and muscle function"
//         },
//         {
//           title: "Congenital Defects",
//           description: "Identify birth defects and structural heart problems"
//         },
//         {
//           title: "Blood Clots",
//           description: "Detect blood clots in heart chambers and assess stroke risk"
//         }
//       ],
//       procedure: [
//         "No fasting required, eat normally before test",
//         "Lie on your left side on examination table",
//         "Gel is applied to chest for better ultrasound contact",
//         "Transducer is moved across chest to capture images",
//         "You may be asked to change positions",
//         "The test is painless and takes 30-45 minutes"
//       ],
//       faqs: [
//         {
//           question: "Is 2D Echo safe?",
//           answer: "Yes, echocardiography is completely safe. It uses sound waves (ultrasound) to create images, not radiation. There are no known risks or side effects. It's even safe during pregnancy."
//         },
//         {
//           question: "Do I need to fast before 2D Echo?",
//           answer: "No, fasting is not required for a standard 2D echo. You can eat and drink normally. However, for a transesophageal echo (TEE), fasting is required - we'll inform you if this type is needed."
//         },
//         {
//           question: "What's the difference between Echo and ECG?",
//           answer: "ECG records electrical activity of the heart, while Echo creates actual images of heart structure and function using ultrasound. Both are important but provide different information."
//         },
//         {
//           question: "Will the test hurt?",
//           answer: "No, the test is painless. You'll feel the transducer moving across your chest and may feel slight pressure, but there's no pain or discomfort. The gel may feel cool on your skin."
//         },
//         {
//           question: "How long before I get results?",
//           answer: "Preliminary findings are often discussed immediately after the test. A complete report with detailed analysis is typically ready within 24 hours and sent to your referring doctor."
//         }
//       ]
//     },
//     'allergy-testing': {
//       title: "Allergy Testing",
//       category: "Immunology",
//       tagline: "Comprehensive Allergen Identification",
//       heroImage: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=1200&q=90",
//       icon: "🤧",
//       color: "#FF9B6E",
//       duration: "45-60 minutes",
//       preparation: "Avoid antihistamines 3-5 days before",
//       overview: "Advanced allergy testing through skin prick tests and blood analysis to identify specific allergens causing your symptoms. Helps create personalized treatment and prevention plans for better allergy management and quality of life.",
//       whatWeOffer: [
//         "Skin prick testing for immediate allergies",
//         "IgE blood tests for comprehensive analysis",
//         "Food allergy panel testing",
//         "Environmental allergen identification",
//         "Drug allergy testing when needed",
//         "Detailed allergy report with recommendations"
//       ],
//       problemsSolved: [
//         {
//           title: "Seasonal Allergies",
//           description: "Identify pollen, grass, and mold allergies causing seasonal symptoms"
//         },
//         {
//           title: "Food Allergies",
//           description: "Pinpoint specific food allergies causing digestive or skin reactions"
//         },
//         {
//           title: "Skin Conditions",
//           description: "Find allergens causing eczema, hives, and other skin reactions"
//         },
//         {
//           title: "Asthma Triggers",
//           description: "Identify allergens that trigger or worsen asthma symptoms"
//         }
//       ],
//       procedure: [
//         "Stop antihistamines 3-5 days before test (consult doctor)",
//         "Small amounts of allergens applied to forearm or back",
//         "Wait 15-20 minutes for reactions to develop",
//         "Results are read and documented",
//         "Blood test may be done if needed",
//         "Detailed discussion of results and treatment plan"
//       ],
//       faqs: [
//         {
//           question: "Is allergy testing painful?",
//           answer: "Skin prick testing causes minimal discomfort - you'll feel a slight prick or scratch. Most people describe it as less painful than a vaccination. Blood testing is similar to a routine blood draw."
//         },
//         {
//           question: "Why should I stop taking antihistamines?",
//           answer: "Antihistamines can block allergic reactions and give false negative results. Stop them 3-5 days before testing (longer for some medications). Always consult your doctor before stopping any medication."
//         },
//         {
//           question: "Can children have allergy testing?",
//           answer: "Yes, children as young as 6 months can be tested. We use age-appropriate methods and our staff is trained in pediatric allergy testing to ensure comfort and accuracy."
//         },
//         {
//           question: "What if I have a severe reaction during testing?",
//           answer: "Testing is done under medical supervision with emergency equipment readily available. Reactions during testing are usually mild and limited to the test site. Severe reactions are extremely rare."
//         },
//         {
//           question: "How accurate is allergy testing?",
//           answer: "Skin prick testing is 85-90% accurate for most common allergens. Combined with your medical history and symptoms, it provides reliable identification of your specific allergies."
//         }
//       ]
//     },
//     'bronchoscopy': {
//       title: "Bronchoscopy",
//       category: "Interventional",
//       tagline: "Advanced Airway Visualization",
//       heroImage: "https://images.unsplash.com/photo-1582560475093-ba66accbc424?w=1200&q=90",
//       icon: "🔬",
//       color: "#2C5F7C",
//       duration: "30-60 minutes",
//       preparation: "Fasting 6 hours before procedure",
//       overview: "Minimally invasive procedure using a flexible bronchoscope to examine airways, collect samples, and perform therapeutic interventions. Performed under sedation for patient comfort, allowing detailed examination and treatment of respiratory conditions.",
//       whatWeOffer: [
//         "Flexible bronchoscopy with advanced equipment",
//         "Diagnostic and therapeutic procedures",
//         "Tissue biopsy for accurate diagnosis",
//         "Bronchoalveolar lavage (BAL)",
//         "Foreign body removal when needed",
//         "Conscious sedation for comfort"
//       ],
//       problemsSolved: [
//         {
//           title: "Persistent Cough",
//           description: "Investigate and treat chronic cough with unknown cause"
//         },
//         {
//           title: "Lung Infections",
//           description: "Collect samples to identify specific infections and guide treatment"
//         },
//         {
//           title: "Lung Cancer",
//           description: "Obtain tissue samples for cancer diagnosis and staging"
//         },
//         {
//           title: "Airway Obstruction",
//           description: "Remove foreign bodies and treat narrowed airways"
//         }
//       ],
//       procedure: [
//         "Fast for 6 hours before procedure",
//         "Local anesthetic applied to throat and nose",
//         "Sedative given for comfort and relaxation",
//         "Flexible bronchoscope inserted through nose or mouth",
//         "Airways examined and samples collected if needed",
//         "Recovery in observation area for 1-2 hours"
//       ],
//       faqs: [
//         {
//           question: "Is bronchoscopy painful?",
//           answer: "No, the procedure is performed under sedation and local anesthesia. You may feel slight pressure or urge to cough, but it shouldn't be painful. Most patients don't remember the procedure afterward."
//         },
//         {
//           question: "How should I prepare for bronchoscopy?",
//           answer: "Fast for at least 6 hours before the procedure. Inform your doctor about all medications, especially blood thinners. Arrange for someone to drive you home as you'll be sedated."
//         },
//         {
//           question: "What are the risks of bronchoscopy?",
//           answer: "Bronchoscopy is very safe. Rare complications may include minor bleeding, reaction to sedation, or temporary breathing difficulty. Our experienced team minimizes these risks."
//         },
//         {
//           question: "How long is the recovery?",
//           answer: "Most people recover quickly. You'll be monitored for 1-2 hours after the procedure. Avoid eating or drinking for 2 hours. Some throat soreness or cough is normal for 1-2 days."
//         },
//         {
//           question: "When will I get biopsy results?",
//           answer: "Initial findings are available immediately. Biopsy results typically take 3-7 days as they require laboratory analysis. Your doctor will discuss results and treatment plan with you."
//         }
//       ]
//     },
//     'thoracoscopy': {
//       title: "Thoracoscopy",
//       category: "Surgical",
//       tagline: "Minimally Invasive Chest Surgery",
//       heroImage: "https://images.unsplash.com/photo-1579154204601-01588f351e67?w=1200&q=90",
//       icon: "🏥",
//       color: "#62B6CB",
//       duration: "1-2 hours",
//       preparation: "Pre-operative evaluation required",
//       overview: "Advanced minimally invasive surgical procedure for diagnosis and treatment of chest conditions. Uses small incisions and a camera for better visualization and faster recovery compared to traditional surgery.",
//       whatWeOffer: [
//         "Video-assisted thoracic surgery (VATS)",
//         "Minimal scarring with small incisions",
//         "Faster recovery than open surgery",
//         "Pleural biopsy for diagnosis",
//         "Fluid drainage and pleurodesis",
//         "Expert surgical team with experience"
//       ],
//       problemsSolved: [
//         {
//           title: "Pleural Effusion",
//           description: "Diagnose and treat fluid accumulation around lungs"
//         },
//         {
//           title: "Lung Nodules",
//           description: "Remove suspicious lung nodules for diagnosis"
//         },
//         {
//           title: "Pneumothorax",
//           description: "Treat collapsed lung and prevent recurrence"
//         },
//         {
//           title: "Pleural Disease",
//           description: "Diagnose and treat various pleural conditions"
//         }
//       ],
//       procedure: [
//         "Pre-operative evaluation and tests",
//         "General anesthesia administered",
//         "Small incisions (1-2 cm) made in chest wall",
//         "Camera and instruments inserted",
//         "Surgical procedure performed",
//         "Hospital stay typically 1-3 days"
//       ],
//       faqs: [
//         {
//           question: "Is thoracoscopy better than open surgery?",
//           answer: "Yes, in most cases. Thoracoscopy offers less pain, smaller scars, faster recovery, and shorter hospital stay compared to open surgery, while providing excellent visualization and results."
//         },
//         {
//           question: "How long is the recovery period?",
//           answer: "Most patients return to light activities within 1-2 weeks and full activities within 4-6 weeks. Recovery is much faster than traditional open chest surgery which can take 2-3 months."
//         },
//         {
//           question: "Will I have chest tubes after surgery?",
//           answer: "Usually yes, a chest tube is placed during surgery to drain fluid and air. It typically stays for 1-3 days and is removed before hospital discharge once drainage is minimal."
//         },
//         {
//           question: "What are the risks of thoracoscopy?",
//           answer: "While generally safe, risks include bleeding, infection, air leak, and rarely, need for conversion to open surgery. Our experienced surgical team minimizes these risks with careful technique."
//         },
//         {
//           question: "How long will I stay in hospital?",
//           answer: "Most thoracoscopy patients stay 1-3 days depending on the procedure and recovery. Some simple procedures may allow same-day or next-day discharge."
//         }
//       ]
//     }
//   };

//   const service = servicesData[serviceId] || servicesData['chest-xray'];

//   const toggleFAQ = (index) => {
//     setOpenFAQ(openFAQ === index ? null : index);
//   };

//   return (
//     <>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700;800&family=Inter:wght@300;400;500;600;700;800&display=swap');
        
//         * {
//           margin: 0;
//           padding: 0;
//           box-sizing: border-box;
//         }

//         body {
//           font-family: 'Inter', sans-serif;
//           color: #1a1a1a;
//         }

//         .service-detail-page {
//           width: 100%;
//           min-height: 100vh;
//           background: linear-gradient(135deg, #F8FAFB 0%, white 100%);
//         }

//         /* Hero Section */
//         .service-hero {
//           position: relative;
//           height: 70vh;
//           min-height: 500px;
//           background-size: cover;
//           background-position: center;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           overflow: hidden;
//         }

//         .service-hero::before {
//           content: '';
//           position: absolute;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background: linear-gradient(135deg, rgba(27, 73, 101, 0.9) 0%, rgba(44, 95, 124, 0.85) 100%);
//         }

//         .service-hero-content {
//           position: relative;
//           z-index: 2;
//           text-align: center;
//           color: white;
//           max-width: 1000px;
//           padding: 2rem;
//         }

//         .back-link {
//           display: inline-flex;
//           align-items: center;
//           gap: 0.5rem;
//           color: white;
//           text-decoration: none;
//           font-weight: 600;
//           margin-bottom: 2rem;
//           padding: 0.8rem 1.5rem;
//           background: rgba(255, 255, 255, 0.1);
//           backdrop-filter: blur(10px);
//           border-radius: 50px;
//           border: 1px solid rgba(255, 255, 255, 0.2);
//           transition: all 0.3s ease;
//         }

//         .back-link:hover {
//           background: rgba(255, 255, 255, 0.2);
//           transform: translateX(-5px);
//         }

//         .service-icon-large {
//           font-size: 5rem;
//           margin-bottom: 1rem;
//           animation: float 3s ease-in-out infinite;
//         }

//         @keyframes float {
//           0%, 100% { transform: translateY(0); }
//           50% { transform: translateY(-10px); }
//         }

//         .service-category-badge {
//           display: inline-block;
//           padding: 0.5rem 1.5rem;
//           background: rgba(255, 155, 110, 0.2);
//           border: 1px solid rgba(255, 155, 110, 0.4);
//           border-radius: 50px;
//           color: #FFD700;
//           font-size: 0.9rem;
//           font-weight: 700;
//           letter-spacing: 2px;
//           text-transform: uppercase;
//           margin-bottom: 1.5rem;
//         }

//         .service-detail-title {
//           font-family: 'Playfair Display', serif;
//           font-size: 4rem;
//           font-weight: 800;
//           margin-bottom: 1rem;
//           line-height: 1.1;
//         }

//         .service-tagline {
//           font-size: 1.5rem;
//           font-weight: 300;
//           opacity: 0.95;
//           margin-bottom: 2rem;
//         }

//         .service-meta {
//           display: flex;
//           gap: 3rem;
//           justify-content: center;
//           flex-wrap: wrap;
//         }

//         .meta-item {
//           display: flex;
//           align-items: center;
//           gap: 0.7rem;
//           font-size: 1.1rem;
//         }

//         /* Quick Contact Bar */
//         .quick-contact-bar {
//           position: sticky;
//           top: 0;
//           z-index: 999;
//           background: white;
//           box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
//           padding: 1.5rem 2rem;
//           margin-top: -50px;
//           margin-bottom: 2rem;
//         }

//         .quick-contact-content {
//           max-width: 1400px;
//           margin: 0 auto;
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           gap: 2rem;
//           flex-wrap: wrap;
//         }

//         .contact-info-compact {
//           display: flex;
//           gap: 2rem;
//           flex-wrap: wrap;
//         }

//         .contact-item-compact {
//           display: flex;
//           align-items: center;
//           gap: 0.7rem;
//           font-size: 0.95rem;
//           color: #1B4965;
//           font-weight: 600;
//         }

//         .contact-item-compact a {
//           color: #1B4965;
//           text-decoration: none;
//           transition: color 0.3s ease;
//         }

//         .contact-item-compact a:hover {
//           color: #E86A33;
//         }

//         .book-button {
//           padding: 1rem 2.5rem;
//           background: linear-gradient(135deg, #E86A33, #FF9B6E);
//           color: white;
//           border: none;
//           border-radius: 50px;
//           font-weight: 700;
//           font-size: 1rem;
//           cursor: pointer;
//           display: flex;
//           align-items: center;
//           gap: 0.7rem;
//           transition: all 0.3s ease;
//           box-shadow: 0 4px 15px rgba(232, 106, 51, 0.3);
//           text-decoration: none;
//         }

//         .book-button:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 6px 25px rgba(232, 106, 51, 0.4);
//         }

//         /* Main Content */
//         .service-content {
//           max-width: 1400px;
//           margin: 0 auto;
//           padding: 4rem 2rem;
//         }

//         .content-grid {
//           display: grid;
//           grid-template-columns: 2fr 1fr;
//           gap: 4rem;
//           align-items: start;
//         }

//         /* Sections */
//         .content-section {
//           background: white;
//           border-radius: 25px;
//           padding: 3rem;
//           box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
//           margin-bottom: 2rem;
//         }

//         .section-title {
//           font-family: 'Playfair Display', serif;
//           font-size: 2.5rem;
//           font-weight: 800;
//           color: #1B4965;
//           margin-bottom: 1.5rem;
//           display: flex;
//           align-items: center;
//           gap: 1rem;
//         }

//         .section-text {
//           font-size: 1.1rem;
//           line-height: 1.9;
//           color: #666;
//           margin-bottom: 2rem;
//         }

//         .feature-list {
//           display: grid;
//           gap: 1rem;
//         }

//         .feature-list-item {
//           display: flex;
//           align-items: flex-start;
//           gap: 1rem;
//           padding: 1rem;
//           background: #F8FAFB;
//           border-radius: 12px;
//           transition: all 0.3s ease;
//         }

//         .feature-list-item:hover {
//           background: #fff;
//           box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
//           transform: translateX(5px);
//         }

//         .feature-icon {
//           color: #E86A33;
//           flex-shrink: 0;
//           margin-top: 0.2rem;
//         }

//         .feature-text {
//           font-size: 1.05rem;
//           line-height: 1.7;
//           color: #1a1a1a;
//         }

//         /* Problems Solved */
//         .problems-grid {
//           display: grid;
//           grid-template-columns: repeat(2, 1fr);
//           gap: 1.5rem;
//           margin-top: 2rem;
//         }

//         .problem-card {
//           padding: 2rem;
//           background: linear-gradient(135deg, #F8FAFB 0%, white 100%);
//           border-radius: 20px;
//           border-left: 4px solid #E86A33;
//           transition: all 0.3s ease;
//         }

//         .problem-card:hover {
//           transform: translateY(-5px);
//           box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
//         }

//         .problem-title {
//           font-size: 1.3rem;
//           font-weight: 700;
//           color: #1B4965;
//           margin-bottom: 0.8rem;
//           display: flex;
//           align-items: center;
//           gap: 0.7rem;
//         }

//         .problem-description {
//           font-size: 1rem;
//           line-height: 1.7;
//           color: #666;
//         }

//         /* Procedure Steps */
//         .procedure-steps {
//           counter-reset: step-counter;
//           display: flex;
//           flex-direction: column;
//           gap: 1.5rem;
//           margin-top: 2rem;
//         }

//         .procedure-step {
//           position: relative;
//           padding-left: 5rem;
//           padding: 1.5rem 1.5rem 1.5rem 5rem;
//           background: #F8FAFB;
//           border-radius: 15px;
//           transition: all 0.3s ease;
//         }

//         .procedure-step:hover {
//           background: white;
//           box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
//         }

//         .procedure-step::before {
//           counter-increment: step-counter;
//           content: counter(step-counter);
//           position: absolute;
//           left: 1.5rem;
//           top: 50%;
//           transform: translateY(-50%);
//           width: 45px;
//           height: 45px;
//           background: linear-gradient(135deg, #E86A33, #FF9B6E);
//           color: white;
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           font-weight: 800;
//           font-size: 1.3rem;
//           font-family: 'Playfair Display', serif;
//         }

//         /* FAQ Section */
//         .faq-list {
//           display: flex;
//           flex-direction: column;
//           gap: 1rem;
//         }

//         .faq-item {
//           background: white;
//           border: 2px solid #f0f0f0;
//           border-radius: 15px;
//           overflow: hidden;
//           transition: all 0.3s ease;
//         }

//         .faq-item.open {
//           border-color: #E86A33;
//           box-shadow: 0 5px 20px rgba(232, 106, 51, 0.1);
//         }

//         .faq-question {
//           padding: 1.5rem 2rem;
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           cursor: pointer;
//           font-weight: 700;
//           font-size: 1.1rem;
//           color: #1B4965;
//           transition: all 0.3s ease;
//         }

//         .faq-question:hover {
//           color: #E86A33;
//         }

//         .faq-answer {
//           padding: 0 2rem 1.5rem;
//           font-size: 1.05rem;
//           line-height: 1.8;
//           color: #666;
//           animation: slideDown 0.3s ease;
//         }

//         @keyframes slideDown {
//           from {
//             opacity: 0;
//             transform: translateY(-10px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         /* Sidebar */
//         .sidebar {
//           position: sticky;
//           top: 200px;
//         }

//         .sidebar-card {
//           background: white;
//           border-radius: 25px;
//           padding: 2.5rem;
//           box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
//           margin-bottom: 2rem;
//         }

//         .sidebar-title {
//           font-size: 1.5rem;
//           font-weight: 700;
//           color: #1B4965;
//           margin-bottom: 1.5rem;
//           font-family: 'Playfair Display', serif;
//         }

//         .info-item {
//           display: flex;
//           align-items: center;
//           justify-content: space-between;
//           padding: 1rem 0;
//           border-bottom: 1px solid #f0f0f0;
//         }

//         .info-item:last-child {
//           border-bottom: none;
//         }

//         .info-label {
//           font-weight: 600;
//           color: #666;
//           font-size: 0.95rem;
//         }

//         .info-value {
//           font-weight: 700;
//           color: #1B4965;
//           font-size: 1rem;
//         }

//         .cta-card {
//           background: linear-gradient(135deg, #1B4965 0%, #2C5F7C 100%);
//           color: white;
//           text-align: center;
//         }

//         .cta-card-title {
//           font-size: 1.8rem;
//           font-weight: 800;
//           margin-bottom: 1rem;
//           font-family: 'Playfair Display', serif;
//         }

//         .cta-card-text {
//           font-size: 1rem;
//           opacity: 0.95;
//           margin-bottom: 1.5rem;
//           line-height: 1.7;
//         }

//         .cta-contact-list {
//           display: flex;
//           flex-direction: column;
//           gap: 1rem;
//           margin: 2rem 0;
//         }

//         .cta-contact-item {
//           display: flex;
//           align-items: center;
//           gap: 1rem;
//           padding: 1rem;
//           background: rgba(255, 255, 255, 0.1);
//           border-radius: 12px;
//           font-weight: 600;
//         }

//         .cta-contact-item a {
//           color: white;
//           text-decoration: none;
//         }

//         .features-badge-list {
//           display: flex;
//           flex-wrap: wrap;
//           gap: 0.8rem;
//           margin-top: 1rem;
//         }

//         .feature-badge {
//           padding: 0.6rem 1.2rem;
//           background: #F8FAFB;
//           border-radius: 50px;
//           font-size: 0.9rem;
//           font-weight: 600;
//           color: #1B4965;
//           display: flex;
//           align-items: center;
//           gap: 0.5rem;
//         }

//         /* Responsive Design */
//         @media (max-width: 1400px) {
//           .service-content {
//             padding: 3rem 1.5rem;
//           }

//           .content-grid {
//             gap: 3rem;
//           }
//         }

//         @media (max-width: 1200px) {
//           .service-hero {
//             height: 60vh;
//             min-height: 450px;
//           }

//           .service-detail-title {
//             font-size: 3.5rem;
//           }

//           .content-grid {
//             gap: 2.5rem;
//           }
//         }

//         @media (max-width: 1024px) {
//           .content-grid {
//             grid-template-columns: 1fr;
//           }

//           .sidebar {
//             position: relative;
//             top: 0;
//           }

//           .problems-grid {
//             grid-template-columns: 1fr;
//           }

//           .service-hero {
//             height: 55vh;
//             min-height: 400px;
//           }

//           .service-detail-title {
//             font-size: 3rem;
//           }

//           .service-tagline {
//             font-size: 1.3rem;
//           }
//         }

//         @media (max-width: 768px) {
//           .service-hero {
//             height: auto;
//             min-height: 350px;
//             padding: 3rem 0;
//           }

//           .service-hero-content {
//             padding: 1.5rem;
//           }

//           .back-link {
//             padding: 0.6rem 1.2rem;
//             font-size: 0.9rem;
//             margin-bottom: 1.5rem;
//           }

//           .service-icon-large {
//             font-size: 3.5rem;
//             margin-bottom: 0.8rem;
//           }

//           .service-category-badge {
//             padding: 0.4rem 1.2rem;
//             font-size: 0.8rem;
//             margin-bottom: 1.2rem;
//           }

//           .service-detail-title {
//             font-size: 2.2rem;
//             line-height: 1.2;
//           }

//           .service-tagline {
//             font-size: 1.1rem;
//             margin-bottom: 1.5rem;
//           }

//           .service-meta {
//             flex-direction: column;
//             gap: 1rem;
//           }

//           .meta-item {
//             font-size: 1rem;
//           }

//           /* Quick Contact Bar */
//           .quick-contact-bar {
//             padding: 1rem;
//             margin-top: -30px;
//           }

//           .quick-contact-content {
//             flex-direction: column;
//             align-items: stretch;
//             gap: 1rem;
//           }

//           .contact-info-compact {
//             flex-direction: column;
//             gap: 0.8rem;
//           }

//           .contact-item-compact {
//             font-size: 0.9rem;
//           }

//           .book-button {
//             padding: 0.9rem 2rem;
//             font-size: 0.95rem;
//             width: 100%;
//             justify-content: center;
//           }

//           /* Content */
//           .service-content {
//             padding: 2rem 1rem;
//           }

//           .content-section {
//             padding: 2rem;
//             border-radius: 20px;
//             margin-bottom: 1.5rem;
//           }

//           .section-title {
//             font-size: 1.8rem;
//             gap: 0.8rem;
//             flex-wrap: wrap;
//           }

//           .section-title svg {
//             width: 28px;
//             height: 28px;
//           }

//           .section-text {
//             font-size: 1rem;
//             line-height: 1.7;
//           }

//           .feature-list-item {
//             padding: 0.9rem;
//             gap: 0.8rem;
//           }

//           .feature-icon {
//             width: 20px;
//             height: 20px;
//           }

//           .feature-text {
//             font-size: 1rem;
//           }

//           .problem-card {
//             padding: 1.5rem;
//           }

//           .problem-title {
//             font-size: 1.1rem;
//             gap: 0.5rem;
//           }

//           .problem-title svg {
//             width: 18px;
//             height: 18px;
//           }

//           .problem-description {
//             font-size: 0.95rem;
//           }

//           .procedure-step {
//             padding: 1.2rem 1.2rem 1.2rem 4.5rem;
//             font-size: 0.95rem;
//           }

//           .procedure-step::before {
//             width: 38px;
//             height: 38px;
//             font-size: 1.1rem;
//             left: 1.2rem;
//           }

//           .faq-question {
//             padding: 1.2rem 1.5rem;
//             font-size: 1rem;
//           }

//           .faq-answer {
//             padding: 0 1.5rem 1.2rem;
//             font-size: 1rem;
//           }

//           /* Sidebar */
//           .sidebar-card {
//             padding: 2rem;
//             border-radius: 20px;
//           }

//           .sidebar-title {
//             font-size: 1.3rem;
//           }

//           .info-item {
//             padding: 0.8rem 0;
//           }

//           .info-label {
//             font-size: 0.9rem;
//           }

//           .info-value {
//             font-size: 0.95rem;
//           }

//           .cta-card-title {
//             font-size: 1.5rem;
//           }

//           .cta-card-text {
//             font-size: 0.95rem;
//           }

//           .cta-contact-list {
//             margin: 1.5rem 0;
//             gap: 0.8rem;
//           }

//           .cta-contact-item {
//             padding: 0.8rem;
//             font-size: 0.9rem;
//           }
//         }

//         @media (max-width: 480px) {
//           .service-hero {
//             min-height: 300px;
//             padding: 2rem 0;
//           }

//           .service-hero-content {
//             padding: 1rem;
//           }

//           .back-link {
//             padding: 0.5rem 1rem;
//             font-size: 0.85rem;
//             margin-bottom: 1.2rem;
//           }

//           .back-link svg {
//             width: 16px;
//             height: 16px;
//           }

//           .service-icon-large {
//             font-size: 2.5rem;
//             margin-bottom: 0.6rem;
//           }

//           .service-category-badge {
//             padding: 0.35rem 1rem;
//             font-size: 0.75rem;
//             letter-spacing: 1px;
//           }

//           .service-detail-title {
//             font-size: 1.8rem;
//             margin-bottom: 0.8rem;
//           }

//           .service-tagline {
//             font-size: 1rem;
//             margin-bottom: 1.2rem;
//           }

//           .meta-item {
//             font-size: 0.9rem;
//             gap: 0.5rem;
//           }

//           .meta-item svg {
//             width: 18px;
//             height: 18px;
//           }

//           /* Quick Contact Bar */
//           .quick-contact-bar {
//             padding: 0.8rem;
//             margin-top: -20px;
//           }

//           .contact-item-compact {
//             font-size: 0.85rem;
//             gap: 0.5rem;
//           }

//           .contact-item-compact svg {
//             width: 16px;
//             height: 16px;
//           }

//           .book-button {
//             padding: 0.8rem 1.5rem;
//             font-size: 0.9rem;
//             gap: 0.5rem;
//           }

//           .book-button svg {
//             width: 18px;
//             height: 18px;
//           }

//           /* Content */
//           .service-content {
//             padding: 1.5rem 0.8rem;
//           }

//           .content-section {
//             padding: 1.5rem;
//             border-radius: 15px;
//             margin-bottom: 1.2rem;
//           }

//           .section-title {
//             font-size: 1.5rem;
//             gap: 0.6rem;
//             margin-bottom: 1.2rem;
//           }

//           .section-title svg {
//             width: 24px;
//             height: 24px;
//           }

//           .section-text {
//             font-size: 0.95rem;
//             line-height: 1.6;
//             margin-bottom: 1.5rem;
//           }

//           .feature-list {
//             gap: 0.8rem;
//           }

//           .feature-list-item {
//             padding: 0.8rem;
//             gap: 0.7rem;
//           }

//           .feature-icon {
//             width: 18px;
//             height: 18px;
//           }

//           .feature-text {
//             font-size: 0.95rem;
//           }

//           .problems-grid {
//             gap: 1.2rem;
//             margin-top: 1.5rem;
//           }

//           .problem-card {
//             padding: 1.2rem;
//             border-radius: 15px;
//           }

//           .problem-title {
//             font-size: 1rem;
//             margin-bottom: 0.6rem;
//           }

//           .problem-description {
//             font-size: 0.9rem;
//             line-height: 1.6;
//           }

//           .procedure-steps {
//             gap: 1.2rem;
//             margin-top: 1.5rem;
//           }

//           .procedure-step {
//             padding: 1rem 1rem 1rem 4rem;
//             font-size: 0.9rem;
//             border-radius: 12px;
//           }

//           .procedure-step::before {
//             width: 35px;
//             height: 35px;
//             font-size: 1rem;
//             left: 1rem;
//           }

//           .faq-list {
//             gap: 0.8rem;
//           }

//           .faq-item {
//             border-radius: 12px;
//           }

//           .faq-question {
//             padding: 1rem 1.2rem;
//             font-size: 0.95rem;
//           }

//           .faq-question svg {
//             width: 20px;
//             height: 20px;
//           }

//           .faq-answer {
//             padding: 0 1.2rem 1rem;
//             font-size: 0.95rem;
//             line-height: 1.6;
//           }

//           /* Sidebar */
//           .sidebar-card {
//             padding: 1.5rem;
//             border-radius: 15px;
//             margin-bottom: 1.5rem;
//           }

//           .sidebar-title {
//             font-size: 1.2rem;
//             margin-bottom: 1.2rem;
//           }

//           .info-item {
//             padding: 0.7rem 0;
//             flex-direction: column;
//             align-items: flex-start;
//             gap: 0.3rem;
//           }

//           .info-label,
//           .info-value {
//             font-size: 0.85rem;
//           }

//           .info-value {
//             font-weight: 600;
//           }

//           .cta-card-title {
//             font-size: 1.3rem;
//             margin-bottom: 0.8rem;
//           }

//           .cta-card-text {
//             font-size: 0.9rem;
//             line-height: 1.6;
//             margin-bottom: 1.2rem;
//           }

//           .cta-contact-list {
//             margin: 1.2rem 0;
//             gap: 0.6rem;
//           }

//           .cta-contact-item {
//             padding: 0.7rem;
//             font-size: 0.85rem;
//             gap: 0.7rem;
//           }

//           .cta-contact-item svg {
//             width: 16px;
//             height: 16px;
//           }

//           .feature-badge {
//             padding: 0.5rem 1rem;
//             font-size: 0.85rem;
//             gap: 0.4rem;
//           }
//         }

//         @media (max-width: 360px) {
//           .service-detail-title {
//             font-size: 1.6rem;
//           }

//           .service-tagline {
//             font-size: 0.95rem;
//           }

//           .section-title {
//             font-size: 1.3rem;
//           }

//           .content-section {
//             padding: 1.2rem;
//           }

//           .procedure-step {
//             padding: 0.9rem 0.9rem 0.9rem 3.5rem;
//           }

//           .procedure-step::before {
//             width: 32px;
//             height: 32px;
//             font-size: 0.95rem;
//             left: 0.8rem;
//           }

//           .faq-question {
//             font-size: 0.9rem;
//           }
//         }
//       `}</style>

//       <div className="service-detail-page">
//         {/* Hero Section */}
//         <section 
//           className="service-hero"
//           style={{backgroundImage: `url(${service.heroImage})`}}
//         >
//           <div className="service-hero-content">
//             <Link to="/" className="back-link">
//               <ArrowLeft size={20} />
//               Back to Home
//             </Link>
            
//             <div className="service-icon-large">{service.icon}</div>
//             <div className="service-category-badge">{service.category}</div>
//             <h1 className="service-detail-title">{service.title}</h1>
//             <p className="service-tagline">{service.tagline}</p>
            
//             <div className="service-meta">
//               <div className="meta-item">
//                 <Clock size={20} />
//                 <span>{service.duration}</span>
//               </div>
//               <div className="meta-item">
//                 <AlertCircle size={20} />
//                 <span>{service.preparation}</span>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* Quick Contact Bar */}
//         <div className="quick-contact-bar">
//           <div className="quick-contact-content">
//             <div className="contact-info-compact">
//               <div className="contact-item-compact">
//                 <Phone size={18} />
//                 <a href="tel:+919989162222">+91 99891 62222</a>
//               </div>
//               <div className="contact-item-compact">
//                 <Mail size={18} />
//                 <a href="mailto:vayulungcare@gmail.com">vayulungcare@gmail.com</a>
//               </div>
//             </div>
//             <a href="#book-appointment" className="book-button">
//               <Calendar size={20} />
//               Book Appointment
//             </a>
//           </div>
//         </div>

//         {/* Main Content */}
//         <div className="service-content">
//           <div className="content-grid">
//             {/* Main Column */}
//             <div>
//               {/* Overview */}
//               <div className="content-section">
//                 <h2 className="section-title">
//                   <Info size={32} />
//                   Overview
//                 </h2>
//                 <p className="section-text">{service.overview}</p>
//               </div>

//               {/* What We Offer */}
//               <div className="content-section">
//                 <h2 className="section-title">
//                   <Shield size={32} />
//                   What We Offer
//                 </h2>
//                 <div className="feature-list">
//                   {service.whatWeOffer.map((item, index) => (
//                     <div key={index} className="feature-list-item">
//                       <CheckCircle size={22} className="feature-icon" />
//                       <span className="feature-text">{item}</span>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               {/* Problems Solved */}
//               <div className="content-section">
//                 <h2 className="section-title">
//                   <Heart size={32} />
//                   Problems We Solve
//                 </h2>
//                 <div className="problems-grid">
//                   {service.problemsSolved.map((problem, index) => (
//                     <div key={index} className="problem-card">
//                       <h3 className="problem-title">
//                         <CheckCircle size={20} />
//                         {problem.title}
//                       </h3>
//                       <p className="problem-description">{problem.description}</p>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               {/* Procedure */}
//               <div className="content-section">
//                 <h2 className="section-title">
//                   <Award size={32} />
//                   What to Expect
//                 </h2>
//                 <div className="procedure-steps">
//                   {service.procedure.map((step, index) => (
//                     <div key={index} className="procedure-step">
//                       {step}
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               {/* FAQs */}
//               <div className="content-section">
//                 <h2 className="section-title">
//                   <AlertCircle size={32} />
//                   Frequently Asked Questions
//                 </h2>
//                 <div className="faq-list">
//                   {service.faqs.map((faq, index) => (
//                     <div 
//                       key={index} 
//                       className={`faq-item ${openFAQ === index ? 'open' : ''}`}
//                     >
//                       <div 
//                         className="faq-question"
//                         onClick={() => toggleFAQ(index)}
//                       >
//                         <span>{faq.question}</span>
//                         {openFAQ === index ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
//                       </div>
//                       {openFAQ === index && (
//                         <div className="faq-answer">
//                           {faq.answer}
//                         </div>
//                       )}
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             </div>

//             {/* Sidebar */}
//             <div className="sidebar">
//               {/* Quick Info */}
//               <div className="sidebar-card">
//                 <h3 className="sidebar-title">Quick Information</h3>
//                 <div className="info-item">
//                   <span className="info-label">Duration</span>
//                   <span className="info-value">{service.duration}</span>
//                 </div>
//                 <div className="info-item">
//                   <span className="info-label">Category</span>
//                   <span className="info-value">{service.category}</span>
//                 </div>
//                 <div className="info-item">
//                   <span className="info-label">Preparation</span>
//                   <span className="info-value">{service.preparation}</span>
//                 </div>
//               </div>

//               {/* CTA Card */}
//               <div className="sidebar-card cta-card" id="book-appointment">
//                 <h3 className="cta-card-title">Ready to Book?</h3>
//                 <p className="cta-card-text">
//                   Schedule your appointment today and take the first step towards better health
//                 </p>
                
//                 <div className="cta-contact-list">
//                   <div className="cta-contact-item">
//                     <Phone size={20} />
//                     <a href="tel:+919989162222">+91 99891 62222</a>
//                   </div>
//                   <div className="cta-contact-item">
//                     <Mail size={20} />
//                     <a href="mailto:vayulungcare@gmail.com">vayulungcare@gmail.com</a>
//                   </div>
//                 </div>

//                 <button className="book-button" style={{width: '100%', justifyContent: 'center'}}>
//                   <Calendar size={20} />
//                   Book Now
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ServiceDetailPage;








import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { 
  ArrowLeft,
  CheckCircle,
  Clock,
  Phone,
  Mail,
  Calendar,
  ChevronDown,
  ChevronUp,
  Award,
  Shield,
  Users,
  AlertCircle,
  Info,
  Heart
} from 'lucide-react';

const ServiceDetailPage = () => {
  const { serviceId } = useParams();
  const [openFAQ, setOpenFAQ] = useState(null);

  // Service data with complete details
  // const servicesData = {
  //   'chest-xray': {
  //     title: "Chest X-Ray",
  //     category: "Diagnostic Imaging",
  //     tagline: "Advanced Digital Radiography for Accurate Diagnosis",
  //     heroImage: "https://images.unsplash.com/photo-1530497610245-94d3c16cda28?w=1200&q=90",
  //     icon: "🔬",
  //     color: "#E86A33",
  //     duration: "15-20 minutes",
  //     preparation: "No special preparation required",
  //     overview: "Our state-of-the-art digital X-ray technology provides comprehensive chest imaging for accurate diagnosis of respiratory conditions, lung infections, and structural abnormalities. With minimal radiation exposure and immediate results, we ensure quick and reliable diagnostic services.",
  //     whatWeOffer: [
  //       "High-resolution digital X-ray imaging",
  //       "Same-day results with expert radiologist reports",
  //       "Low radiation exposure technology",
  //       "Portable X-ray services available",
  //       "Comparison with previous images",
  //       "Digital archiving for easy access"
  //     ],
  //     problemsSolved: [
  //       {
  //         title: "Respiratory Infections",
  //         description: "Detect pneumonia, tuberculosis, and other lung infections early for prompt treatment"
  //       },
  //       {
  //         title: "Lung Conditions",
  //         description: "Identify COPD, emphysema, bronchitis, and other chronic lung diseases"
  //       },
  //       {
  //         title: "Heart Issues",
  //         description: "Assess heart size, shape, and detect fluid around the heart"
  //       },
  //       {
  //         title: "Bone Problems",
  //         description: "Detect rib fractures, spine abnormalities, and chest wall issues"
  //       }
  //     ],
  //     procedure: [
  //       "You'll be asked to remove jewelry and metal objects",
  //       "Stand or sit in front of the X-ray machine",
  //       "Follow breathing instructions from the technician",
  //       "Images are captured in just a few seconds",
  //       "You can resume normal activities immediately"
  //     ],
  //     faqs: [
  //       {
  //         question: "Is chest X-ray safe?",
  //         answer: "Yes, chest X-rays are very safe. The amount of radiation exposure is minimal and the benefits of accurate diagnosis far outweigh the risks. Our modern equipment uses the lowest possible radiation doses."
  //       },
  //       {
  //         question: "Do I need to prepare for a chest X-ray?",
  //         answer: "No special preparation is needed. You can eat and drink normally. Just wear comfortable clothing and remove any jewelry or metal objects from your chest area."
  //       },
  //       {
  //         question: "How long does it take to get results?",
  //         answer: "Digital X-ray results are available within a few hours. Our radiologist will review the images and provide a detailed report the same day. Urgent cases are prioritized."
  //       },
  //       {
  //         question: "Can pregnant women have chest X-rays?",
  //         answer: "We generally avoid X-rays during pregnancy unless absolutely necessary. Please inform us if you are or might be pregnant, and we'll discuss safer alternatives with your doctor."
  //       },
  //       {
  //         question: "How often can I have a chest X-ray?",
  //         answer: "The frequency depends on your medical condition. Your doctor will determine the appropriate timing. Modern equipment uses very low radiation, making it safe for regular monitoring when medically necessary."
  //       }
  //     ]
  //   }
  //   // Add other services as needed
  // };
    const servicesData = {
    'chest-xray': {
      title: "Chest X-Ray",
      category: "Diagnostic Imaging",
      tagline: "Advanced Digital Radiography for Accurate Diagnosis",
      heroImage: "https://images.unsplash.com/photo-1530497610245-94d3c16cda28?w=1200&q=90",
      icon: "🔬",
      color: "#E86A33",
      duration: "15-20 minutes",
      preparation: "No special preparation required",
      overview: "Our state-of-the-art digital X-ray technology provides comprehensive chest imaging for accurate diagnosis of respiratory conditions, lung infections, and structural abnormalities. With minimal radiation exposure and immediate results, we ensure quick and reliable diagnostic services.",
      whatWeOffer: [
        "High-resolution digital X-ray imaging",
        "Same-day results with expert radiologist reports",
        "Low radiation exposure technology",
        "Portable X-ray services available",
        "Comparison with previous images",
        "Digital archiving for easy access"
      ],
      problemsSolved: [
        {
          title: "Respiratory Infections",
          description: "Detect pneumonia, tuberculosis, and other lung infections early for prompt treatment"
        },
        {
          title: "Lung Conditions",
          description: "Identify COPD, emphysema, bronchitis, and other chronic lung diseases"
        },
        {
          title: "Heart Issues",
          description: "Assess heart size, shape, and detect fluid around the heart"
        },
        {
          title: "Bone Problems",
          description: "Detect rib fractures, spine abnormalities, and chest wall issues"
        }
      ],
      procedure: [
        "You'll be asked to remove jewelry and metal objects",
        "Stand or sit in front of the X-ray machine",
        "Follow breathing instructions from the technician",
        "Images are captured in just a few seconds",
        "You can resume normal activities immediately"
      ],
      faqs: [
        {
          question: "Is chest X-ray safe?",
          answer: "Yes, chest X-rays are very safe. The amount of radiation exposure is minimal and the benefits of accurate diagnosis far outweigh the risks. Our modern equipment uses the lowest possible radiation doses."
        },
        {
          question: "Do I need to prepare for a chest X-ray?",
          answer: "No special preparation is needed. You can eat and drink normally. Just wear comfortable clothing and remove any jewelry or metal objects from your chest area."
        },
        {
          question: "How long does it take to get results?",
          answer: "Digital X-ray results are available within a few hours. Our radiologist will review the images and provide a detailed report the same day. Urgent cases are prioritized."
        },
        {
          question: "Can pregnant women have chest X-rays?",
          answer: "We generally avoid X-rays during pregnancy unless absolutely necessary. Please inform us if you are or might be pregnant, and we'll discuss safer alternatives with your doctor."
        },
        {
          question: "How often can I have a chest X-ray?",
          answer: "The frequency depends on your medical condition. Your doctor will determine the appropriate timing. Modern equipment uses very low radiation, making it safe for regular monitoring when medically necessary."
        }
      ]
    },
    'pft': {
      title: "PFT (Pulmonary Function Test)",
      category: "Respiratory Testing",
      tagline: "Comprehensive Lung Function Evaluation",
      heroImage: "https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=1200&q=90",
      icon: "🫁",
      color: "#2C85B8",
      duration: "30-45 minutes",
      preparation: "Avoid heavy meals 2 hours before test",
      overview: "Complete pulmonary function testing to measure lung capacity, airflow rates, and gas exchange efficiency. Essential for diagnosing and monitoring respiratory conditions like asthma, COPD, and interstitial lung diseases. Our comprehensive testing provides detailed insights into your lung health.",
      whatWeOffer: [
        "Spirometry testing with advanced equipment",
        "Lung volume measurement",
        "Diffusion capacity testing (DLCO)",
        "Exercise testing for respiratory assessment",
        "Pre and post-bronchodilator testing",
        "Detailed analysis reports with interpretation"
      ],
      problemsSolved: [
        {
          title: "Asthma Management",
          description: "Accurately diagnose asthma severity and monitor treatment effectiveness"
        },
        {
          title: "COPD Monitoring",
          description: "Track disease progression and optimize treatment plans for COPD patients"
        },
        {
          title: "Occupational Lung Disease",
          description: "Assess workplace exposure effects and monitor lung health"
        },
        {
          title: "Pre-Surgery Evaluation",
          description: "Determine lung function before surgery to ensure safety"
        }
      ],
      procedure: [
        "Avoid using inhalers 4-6 hours before test (unless instructed)",
        "You'll be seated comfortably and fitted with a mouthpiece",
        "Follow breathing instructions carefully",
        "Perform various breathing maneuvers as directed",
        "Test may be repeated for accuracy",
        "Bronchodilator may be given to test response"
      ],
      faqs: [
        {
          question: "Is the PFT test painful?",
          answer: "No, PFT is completely painless and non-invasive. You'll simply breathe into a mouthpiece following our technician's instructions. Some people may feel slightly out of breath during certain maneuvers, but this is temporary and normal."
        },
        {
          question: "Can I use my inhaler before the test?",
          answer: "Please avoid using short-acting inhalers 4-6 hours before the test and long-acting inhalers 12 hours before. However, if you're having severe breathing difficulty, use your inhaler and inform us. We may need to reschedule."
        },
        {
          question: "How should I prepare for PFT?",
          answer: "Avoid heavy meals 2 hours before the test, wear loose comfortable clothing, and avoid smoking for at least 1 hour before. Take your regular medications unless specifically instructed otherwise by your doctor."
        },
        {
          question: "Why do I need to repeat the breathing tests?",
          answer: "We typically perform each maneuver 3 times to ensure accuracy and consistency. This helps us get the most reliable measurements of your lung function."
        },
        {
          question: "When will I get my results?",
          answer: "Results are typically available within 24 hours. Your doctor will receive a detailed report with interpretation and recommendations for your treatment plan."
        }
      ]
    },
    'ecg': {
      title: "ECG (Electrocardiogram)",
      category: "Cardiac Testing",
      tagline: "Comprehensive Heart Monitoring",
      heroImage: "https://images.unsplash.com/photo-1628595351029-c2bf17511435?w=1200&q=90",
      icon: "❤️",
      color: "#E63946",
      duration: "10-15 minutes",
      preparation: "No special preparation needed",
      overview: "Non-invasive cardiac monitoring to detect arrhythmias, heart disease, and circulation issues. Our 12-lead ECG provides immediate results for accurate cardiac assessment, helping identify heart problems early and monitor treatment effectiveness.",
      whatWeOffer: [
        "12-lead ECG with latest technology",
        "Immediate digital results",
        "Arrhythmia detection and analysis",
        "Heart health comprehensive assessment",
        "Comparison with previous ECGs",
        "Expert cardiologist review and interpretation"
      ],
      problemsSolved: [
        {
          title: "Heart Rhythm Disorders",
          description: "Detect irregular heartbeats, atrial fibrillation, and other arrhythmias"
        },
        {
          title: "Heart Attack Screening",
          description: "Identify signs of past or ongoing heart attacks for immediate intervention"
        },
        {
          title: "Heart Disease Monitoring",
          description: "Track coronary artery disease, heart failure, and valve problems"
        },
        {
          title: "Medication Effects",
          description: "Monitor how heart medications are affecting your cardiac function"
        }
      ],
      procedure: [
        "Wear comfortable, loose-fitting clothing",
        "Electrodes are placed on chest, arms, and legs",
        "You'll lie still for a few minutes during recording",
        "The test is completely painless",
        "Results are available immediately",
        "You can resume all normal activities right away"
      ],
      faqs: [
        {
          question: "Is an ECG test safe?",
          answer: "Yes, ECG is completely safe and non-invasive. It only records your heart's electrical activity and doesn't send any electricity into your body. There are no risks or side effects."
        },
        {
          question: "Do I need to prepare for an ECG?",
          answer: "No special preparation is needed. Just avoid using oily or greasy lotions on your chest as they may interfere with electrode placement. Wear comfortable clothing that allows easy access to your chest."
        },
        {
          question: "What can an ECG detect?",
          answer: "An ECG can detect irregular heart rhythms, heart attacks (past or present), heart enlargement, inadequate blood or oxygen supply to the heart, and various other cardiac conditions."
        },
        {
          question: "How long does an ECG take?",
          answer: "The actual recording takes only about 5-10 minutes. With preparation and electrode placement, the entire process typically takes 10-15 minutes."
        },
        {
          question: "Will I get results immediately?",
          answer: "Yes, the ECG recording is available immediately. Our cardiologist will review it and provide a detailed interpretation report, usually within a few hours for routine cases."
        }
      ]
    },
    '2d-echo': {
      title: "2D ECHO (Echocardiography)",
      category: "Cardiac Imaging",
      tagline: "Advanced Heart Imaging Technology",
      heroImage: "https://images.unsplash.com/photo-1559757175-5700dde675bc?w=1200&q=90",
      icon: "🫀",
      color: "#1B4965",
      duration: "30-45 minutes",
      preparation: "No fasting required",
      overview: "Sophisticated ultrasound imaging providing real-time visualization of heart structure, function, and blood flow patterns. Essential for evaluating heart valves, chambers, and overall cardiac performance with detailed Doppler studies and color flow mapping.",
      whatWeOffer: [
        "Real-time heart imaging with latest equipment",
        "Valve function detailed assessment",
        "Chamber size and wall motion analysis",
        "Blood flow velocity evaluation",
        "Doppler studies for comprehensive analysis",
        "Color flow mapping for visualization"
      ],
      problemsSolved: [
        {
          title: "Valve Problems",
          description: "Detect valve stenosis, regurgitation, and structural abnormalities"
        },
        {
          title: "Heart Muscle Disease",
          description: "Assess cardiomyopathy, heart failure, and muscle function"
        },
        {
          title: "Congenital Defects",
          description: "Identify birth defects and structural heart problems"
        },
        {
          title: "Blood Clots",
          description: "Detect blood clots in heart chambers and assess stroke risk"
        }
      ],
      procedure: [
        "No fasting required, eat normally before test",
        "Lie on your left side on examination table",
        "Gel is applied to chest for better ultrasound contact",
        "Transducer is moved across chest to capture images",
        "You may be asked to change positions",
        "The test is painless and takes 30-45 minutes"
      ],
      faqs: [
        {
          question: "Is 2D Echo safe?",
          answer: "Yes, echocardiography is completely safe. It uses sound waves (ultrasound) to create images, not radiation. There are no known risks or side effects. It's even safe during pregnancy."
        },
        {
          question: "Do I need to fast before 2D Echo?",
          answer: "No, fasting is not required for a standard 2D echo. You can eat and drink normally. However, for a transesophageal echo (TEE), fasting is required - we'll inform you if this type is needed."
        },
        {
          question: "What's the difference between Echo and ECG?",
          answer: "ECG records electrical activity of the heart, while Echo creates actual images of heart structure and function using ultrasound. Both are important but provide different information."
        },
        {
          question: "Will the test hurt?",
          answer: "No, the test is painless. You'll feel the transducer moving across your chest and may feel slight pressure, but there's no pain or discomfort. The gel may feel cool on your skin."
        },
        {
          question: "How long before I get results?",
          answer: "Preliminary findings are often discussed immediately after the test. A complete report with detailed analysis is typically ready within 24 hours and sent to your referring doctor."
        }
      ]
    },
    'allergy-testing': {
      title: "Allergy Testing",
      category: "Immunology",
      tagline: "Comprehensive Allergen Identification",
      heroImage: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=1200&q=90",
      icon: "🤧",
      color: "#FF9B6E",
      duration: "45-60 minutes",
      preparation: "Avoid antihistamines 3-5 days before",
      overview: "Advanced allergy testing through skin prick tests and blood analysis to identify specific allergens causing your symptoms. Helps create personalized treatment and prevention plans for better allergy management and quality of life.",
      whatWeOffer: [
        "Skin prick testing for immediate allergies",
        "IgE blood tests for comprehensive analysis",
        "Food allergy panel testing",
        "Environmental allergen identification",
        "Drug allergy testing when needed",
        "Detailed allergy report with recommendations"
      ],
      problemsSolved: [
        {
          title: "Seasonal Allergies",
          description: "Identify pollen, grass, and mold allergies causing seasonal symptoms"
        },
        {
          title: "Food Allergies",
          description: "Pinpoint specific food allergies causing digestive or skin reactions"
        },
        {
          title: "Skin Conditions",
          description: "Find allergens causing eczema, hives, and other skin reactions"
        },
        {
          title: "Asthma Triggers",
          description: "Identify allergens that trigger or worsen asthma symptoms"
        }
      ],
      procedure: [
        "Stop antihistamines 3-5 days before test (consult doctor)",
        "Small amounts of allergens applied to forearm or back",
        "Wait 15-20 minutes for reactions to develop",
        "Results are read and documented",
        "Blood test may be done if needed",
        "Detailed discussion of results and treatment plan"
      ],
      faqs: [
        {
          question: "Is allergy testing painful?",
          answer: "Skin prick testing causes minimal discomfort - you'll feel a slight prick or scratch. Most people describe it as less painful than a vaccination. Blood testing is similar to a routine blood draw."
        },
        {
          question: "Why should I stop taking antihistamines?",
          answer: "Antihistamines can block allergic reactions and give false negative results. Stop them 3-5 days before testing (longer for some medications). Always consult your doctor before stopping any medication."
        },
        {
          question: "Can children have allergy testing?",
          answer: "Yes, children as young as 6 months can be tested. We use age-appropriate methods and our staff is trained in pediatric allergy testing to ensure comfort and accuracy."
        },
        {
          question: "What if I have a severe reaction during testing?",
          answer: "Testing is done under medical supervision with emergency equipment readily available. Reactions during testing are usually mild and limited to the test site. Severe reactions are extremely rare."
        },
        {
          question: "How accurate is allergy testing?",
          answer: "Skin prick testing is 85-90% accurate for most common allergens. Combined with your medical history and symptoms, it provides reliable identification of your specific allergies."
        }
      ]
    },
    'bronchoscopy': {
      title: "Bronchoscopy",
      category: "Interventional",
      tagline: "Advanced Airway Visualization",
      heroImage: "https://images.unsplash.com/photo-1582560475093-ba66accbc424?w=1200&q=90",
      icon: "🔬",
      color: "#2C5F7C",
      duration: "30-60 minutes",
      preparation: "Fasting 6 hours before procedure",
      overview: "Minimally invasive procedure using a flexible bronchoscope to examine airways, collect samples, and perform therapeutic interventions. Performed under sedation for patient comfort, allowing detailed examination and treatment of respiratory conditions.",
      whatWeOffer: [
        "Flexible bronchoscopy with advanced equipment",
        "Diagnostic and therapeutic procedures",
        "Tissue biopsy for accurate diagnosis",
        "Bronchoalveolar lavage (BAL)",
        "Foreign body removal when needed",
        "Conscious sedation for comfort"
      ],
      problemsSolved: [
        {
          title: "Persistent Cough",
          description: "Investigate and treat chronic cough with unknown cause"
        },
        {
          title: "Lung Infections",
          description: "Collect samples to identify specific infections and guide treatment"
        },
        {
          title: "Lung Cancer",
          description: "Obtain tissue samples for cancer diagnosis and staging"
        },
        {
          title: "Airway Obstruction",
          description: "Remove foreign bodies and treat narrowed airways"
        }
      ],
      procedure: [
        "Fast for 6 hours before procedure",
        "Local anesthetic applied to throat and nose",
        "Sedative given for comfort and relaxation",
        "Flexible bronchoscope inserted through nose or mouth",
        "Airways examined and samples collected if needed",
        "Recovery in observation area for 1-2 hours"
      ],
      faqs: [
        {
          question: "Is bronchoscopy painful?",
          answer: "No, the procedure is performed under sedation and local anesthesia. You may feel slight pressure or urge to cough, but it shouldn't be painful. Most patients don't remember the procedure afterward."
        },
        {
          question: "How should I prepare for bronchoscopy?",
          answer: "Fast for at least 6 hours before the procedure. Inform your doctor about all medications, especially blood thinners. Arrange for someone to drive you home as you'll be sedated."
        },
        {
          question: "What are the risks of bronchoscopy?",
          answer: "Bronchoscopy is very safe. Rare complications may include minor bleeding, reaction to sedation, or temporary breathing difficulty. Our experienced team minimizes these risks."
        },
        {
          question: "How long is the recovery?",
          answer: "Most people recover quickly. You'll be monitored for 1-2 hours after the procedure. Avoid eating or drinking for 2 hours. Some throat soreness or cough is normal for 1-2 days."
        },
        {
          question: "When will I get biopsy results?",
          answer: "Initial findings are available immediately. Biopsy results typically take 3-7 days as they require laboratory analysis. Your doctor will discuss results and treatment plan with you."
        }
      ]
    },
    'thoracoscopy': {
      title: "Thoracoscopy",
      category: "Surgical",
      tagline: "Minimally Invasive Chest Surgery",
      heroImage: "https://images.unsplash.com/photo-1579154204601-01588f351e67?w=1200&q=90",
      icon: "🏥",
      color: "#62B6CB",
      duration: "1-2 hours",
      preparation: "Pre-operative evaluation required",
      overview: "Advanced minimally invasive surgical procedure for diagnosis and treatment of chest conditions. Uses small incisions and a camera for better visualization and faster recovery compared to traditional surgery.",
      whatWeOffer: [
        "Video-assisted thoracic surgery (VATS)",
        "Minimal scarring with small incisions",
        "Faster recovery than open surgery",
        "Pleural biopsy for diagnosis",
        "Fluid drainage and pleurodesis",
        "Expert surgical team with experience"
      ],
      problemsSolved: [
        {
          title: "Pleural Effusion",
          description: "Diagnose and treat fluid accumulation around lungs"
        },
        {
          title: "Lung Nodules",
          description: "Remove suspicious lung nodules for diagnosis"
        },
        {
          title: "Pneumothorax",
          description: "Treat collapsed lung and prevent recurrence"
        },
        {
          title: "Pleural Disease",
          description: "Diagnose and treat various pleural conditions"
        }
      ],
      procedure: [
        "Pre-operative evaluation and tests",
        "General anesthesia administered",
        "Small incisions (1-2 cm) made in chest wall",
        "Camera and instruments inserted",
        "Surgical procedure performed",
        "Hospital stay typically 1-3 days"
      ],
      faqs: [
        {
          question: "Is thoracoscopy better than open surgery?",
          answer: "Yes, in most cases. Thoracoscopy offers less pain, smaller scars, faster recovery, and shorter hospital stay compared to open surgery, while providing excellent visualization and results."
        },
        {
          question: "How long is the recovery period?",
          answer: "Most patients return to light activities within 1-2 weeks and full activities within 4-6 weeks. Recovery is much faster than traditional open chest surgery which can take 2-3 months."
        },
        {
          question: "Will I have chest tubes after surgery?",
          answer: "Usually yes, a chest tube is placed during surgery to drain fluid and air. It typically stays for 1-3 days and is removed before hospital discharge once drainage is minimal."
        },
        {
          question: "What are the risks of thoracoscopy?",
          answer: "While generally safe, risks include bleeding, infection, air leak, and rarely, need for conversion to open surgery. Our experienced surgical team minimizes these risks with careful technique."
        },
        {
          question: "How long will I stay in hospital?",
          answer: "Most thoracoscopy patients stay 1-3 days depending on the procedure and recovery. Some simple procedures may allow same-day or next-day discharge."
        }
      ]
    }
  };

  const service = servicesData[serviceId] || servicesData['chest-xray'];

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700;800&family=Inter:wght@300;400;500;600;700;800&display=swap');
        
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          font-family: 'Inter', sans-serif;
          color: #1a1a1a;
        }

        .service-detail-page {
          width: 100%;
          min-height: 100vh;
          background: linear-gradient(135deg, #F8FAFB 0%, white 100%);
        }

        /* Hero Section */
        .service-hero {
          position: relative;
          height: 70vh;
          min-height: 500px;
          background-size: cover;
          background-position: center;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }

        .service-hero::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, rgba(27, 73, 101, 0.9) 0%, rgba(44, 95, 124, 0.85) 100%);
        }

        .service-hero-content {
          position: relative;
          z-index: 2;
          text-align: center;
          color: white;
          max-width: 1000px;
          padding: 2rem;
        }

        .back-link {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          color: white;
          text-decoration: none;
          font-weight: 600;
          margin-bottom: 2rem;
          padding: 0.8rem 1.5rem;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          border-radius: 50px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          transition: all 0.3s ease;
        }

        .back-link:hover {
          background: rgba(255, 255, 255, 0.2);
          transform: translateX(-5px);
        }

        .service-icon-large {
          font-size: 5rem;
          margin-bottom: 1rem;
          animation: float 3s ease-in-out infinite;
        }

        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }

        .service-category-badge {
          display: inline-block;
          padding: 0.5rem 1.5rem;
          background: rgba(255, 155, 110, 0.2);
          border: 1px solid rgba(255, 155, 110, 0.4);
          border-radius: 50px;
          color: #FFD700;
          font-size: 0.9rem;
          font-weight: 700;
          letter-spacing: 2px;
          text-transform: uppercase;
          margin-bottom: 1.5rem;
        }

        .service-detail-title {
          font-family: 'Playfair Display', serif;
          font-size: 4rem;
          font-weight: 800;
          margin-bottom: 1rem;
          line-height: 1.1;
        }

        .service-tagline {
          font-size: 1.5rem;
          font-weight: 300;
          opacity: 0.95;
          margin-bottom: 2rem;
        }

        .service-meta {
          display: flex;
          gap: 3rem;
          justify-content: center;
          flex-wrap: wrap;
        }

        .meta-item {
          display: flex;
          align-items: center;
          gap: 0.7rem;
          font-size: 1.1rem;
        }

        /* Quick Contact Bar */
        .quick-contact-bar {
          position: sticky;
          top: 0;
          z-index: 999;
          background: white;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
          padding: 1.5rem 2rem;
          margin-top: -50px;
          margin-bottom: 2rem;
        }

        .quick-contact-content {
          max-width: 1400px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 2rem;
          flex-wrap: wrap;
        }

        .contact-info-compact {
          display: flex;
          gap: 2rem;
          flex-wrap: wrap;
        }

        .contact-item-compact {
          display: flex;
          align-items: center;
          gap: 0.7rem;
          font-size: 0.95rem;
          color: #1B4965;
          font-weight: 600;
        }

        .contact-item-compact a {
          color: #1B4965;
          text-decoration: none;
          transition: color 0.3s ease;
        }

        .contact-item-compact a:hover {
          color: #E86A33;
        }

        .book-button {
          padding: 1rem 2.5rem;
          background: linear-gradient(135deg, #E86A33, #FF9B6E);
          color: white;
          border: none;
          border-radius: 50px;
          font-weight: 700;
          font-size: 1rem;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 0.7rem;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(232, 106, 51, 0.3);
          text-decoration: none;
        }

        .book-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 25px rgba(232, 106, 51, 0.4);
        }

        /* Main Content */
        .service-content {
          max-width: 1400px;
          margin: 0 auto;
          padding: 4rem 2rem;
        }

        .content-grid {
          display: grid;
          grid-template-columns: 2fr 1fr;
          gap: 4rem;
          align-items: start;
        }

        /* Sections */
        .content-section {
          background: white;
          border-radius: 25px;
          padding: 3rem;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
          margin-bottom: 2rem;
        }

        .section-title {
          font-family: 'Playfair Display', serif;
          font-size: 2.5rem;
          font-weight: 800;
          color: #1B4965;
          margin-bottom: 1.5rem;
          display: flex;
          align-items: center;
          gap: 1rem;
        }

        .section-text {
          font-size: 1.1rem;
          line-height: 1.9;
          color: #666;
          margin-bottom: 2rem;
        }

        .feature-list {
          display: grid;
          gap: 1rem;
        }

        .feature-list-item {
          display: flex;
          align-items: flex-start;
          gap: 1rem;
          padding: 1rem;
          background: #F8FAFB;
          border-radius: 12px;
          transition: all 0.3s ease;
        }

        .feature-list-item:hover {
          background: #fff;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
          transform: translateX(5px);
        }

        .feature-icon {
          color: #E86A33;
          flex-shrink: 0;
          margin-top: 0.2rem;
        }

        .feature-text {
          font-size: 1.05rem;
          line-height: 1.7;
          color: #1a1a1a;
        }

        /* Problems Solved */
        .problems-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 1.5rem;
          margin-top: 2rem;
        }

        .problem-card {
          padding: 2rem;
          background: linear-gradient(135deg, #F8FAFB 0%, white 100%);
          border-radius: 20px;
          border-left: 4px solid #E86A33;
          transition: all 0.3s ease;
        }

        .problem-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
        }

        .problem-title {
          font-size: 1.3rem;
          font-weight: 700;
          color: #1B4965;
          margin-bottom: 0.8rem;
          display: flex;
          align-items: center;
          gap: 0.7rem;
        }

        .problem-description {
          font-size: 1rem;
          line-height: 1.7;
          color: #666;
        }

        /* Procedure Steps */
        .procedure-steps {
          counter-reset: step-counter;
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
          margin-top: 2rem;
        }

        .procedure-step {
          position: relative;
          padding-left: 5rem;
          padding: 1.5rem 1.5rem 1.5rem 5rem;
          background: #F8FAFB;
          border-radius: 15px;
          transition: all 0.3s ease;
        }

        .procedure-step:hover {
          background: white;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
        }

        .procedure-step::before {
          counter-increment: step-counter;
          content: counter(step-counter);
          position: absolute;
          left: 1.5rem;
          top: 50%;
          transform: translateY(-50%);
          width: 45px;
          height: 45px;
          background: linear-gradient(135deg, #E86A33, #FF9B6E);
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 800;
          font-size: 1.3rem;
          font-family: 'Playfair Display', serif;
        }

        /* FAQ Section */
        .faq-list {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .faq-item {
          background: white;
          border: 2px solid #f0f0f0;
          border-radius: 15px;
          overflow: hidden;
          transition: all 0.3s ease;
        }

        .faq-item.open {
          border-color: #E86A33;
          box-shadow: 0 5px 20px rgba(232, 106, 51, 0.1);
        }

        .faq-question {
          padding: 1.5rem 2rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          font-weight: 700;
          font-size: 1.1rem;
          color: #1B4965;
          transition: all 0.3s ease;
        }

        .faq-question:hover {
          color: #E86A33;
        }

        .faq-answer {
          padding: 0 2rem 1.5rem;
          font-size: 1.05rem;
          line-height: 1.8;
          color: #666;
          animation: slideDown 0.3s ease;
        }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* Sidebar */
        .sidebar {
          position: sticky;
          top: 200px;
        }

        .sidebar-card {
          background: white;
          border-radius: 25px;
          padding: 2.5rem;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
          margin-bottom: 2rem;
        }

        .sidebar-title {
          font-size: 1.5rem;
          font-weight: 700;
          color: #1B4965;
          margin-bottom: 1.5rem;
          font-family: 'Playfair Display', serif;
        }

        .info-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 1rem 0;
          border-bottom: 1px solid #f0f0f0;
        }

        .info-item:last-child {
          border-bottom: none;
        }

        .info-label {
          font-weight: 600;
          color: #666;
          font-size: 0.95rem;
        }

        .info-value {
          font-weight: 700;
          color: #1B4965;
          font-size: 1rem;
        }

        .cta-card {
          background: linear-gradient(135deg, #1B4965 0%, #2C5F7C 100%);
          color: white;
          text-align: center;
        }

        .cta-card-title {
          font-size: 1.8rem;
          font-weight: 800;
          margin-bottom: 1rem;
          font-family: 'Playfair Display', serif;
        }

        .cta-card-text {
          font-size: 1rem;
          opacity: 0.95;
          margin-bottom: 1.5rem;
          line-height: 1.7;
        }

        .cta-contact-list {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          margin: 2rem 0;
        }

        .cta-contact-item {
          display: flex;
          align-items: center;
          gap: 1rem;
          padding: 1rem;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 12px;
          font-weight: 600;
        }

        .cta-contact-item a {
          color: white;
          text-decoration: none;
        }

        .features-badge-list {
          display: flex;
          flex-wrap: wrap;
          gap: 0.8rem;
          margin-top: 1rem;
        }

        .feature-badge {
          padding: 0.6rem 1.2rem;
          background: #F8FAFB;
          border-radius: 50px;
          font-size: 0.9rem;
          font-weight: 600;
          color: #1B4965;
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        /* Responsive Design */
        @media (max-width: 1400px) {
          .service-content {
            padding: 3rem 1.5rem;
          }

          .content-grid {
            gap: 3rem;
          }
        }

        @media (max-width: 1200px) {
          .service-hero {
            height: 60vh;
            min-height: 450px;
          }

          .service-detail-title {
            font-size: 3.5rem;
          }

          .content-grid {
            gap: 2.5rem;
          }
        }

        @media (max-width: 1024px) {
          .content-grid {
            grid-template-columns: 1fr;
          }

          .sidebar {
            position: relative;
            top: 0;
          }

          .problems-grid {
            grid-template-columns: 1fr;
          }

          .service-hero {
            height: 55vh;
            min-height: 400px;
          }

          .service-detail-title {
            font-size: 3rem;
          }

          .service-tagline {
            font-size: 1.3rem;
          }
        }

        @media (max-width: 768px) {
          .service-hero {
            height: auto;
            min-height: 350px;
            padding: 3rem 0;
          }

          .service-hero-content {
            padding: 1.5rem;
          }

          .back-link {
            padding: 0.6rem 1.2rem;
            font-size: 0.9rem;
            margin-bottom: 1.5rem;
          }

          .service-icon-large {
            font-size: 3.5rem;
            margin-bottom: 0.8rem;
          }

          .service-category-badge {
            padding: 0.4rem 1.2rem;
            font-size: 0.8rem;
            margin-bottom: 1.2rem;
          }

          .service-detail-title {
            font-size: 2.2rem;
            line-height: 1.2;
          }

          .service-tagline {
            font-size: 1.1rem;
            margin-bottom: 1.5rem;
          }

          .service-meta {
            flex-direction: column;
            gap: 1rem;
          }

          .meta-item {
            font-size: 1rem;
          }

          /* Quick Contact Bar */
          .quick-contact-bar {
            padding: 1rem;
            margin-top: -30px;
          }

          .quick-contact-content {
            flex-direction: column;
            align-items: stretch;
            gap: 1rem;
          }

          .contact-info-compact {
            flex-direction: column;
            gap: 0.8rem;
          }

          .contact-item-compact {
            font-size: 0.9rem;
          }

          .book-button {
            padding: 0.9rem 2rem;
            font-size: 0.95rem;
            width: 100%;
            justify-content: center;
          }

          /* Content */
          .service-content {
            padding: 2rem 1rem;
          }

          .content-section {
            padding: 2rem;
            border-radius: 20px;
            margin-bottom: 1.5rem;
          }

          .section-title {
            font-size: 1.8rem;
            gap: 0.8rem;
            flex-wrap: wrap;
          }

          .section-title svg {
            width: 28px;
            height: 28px;
          }

          .section-text {
            font-size: 1rem;
            line-height: 1.7;
          }

          .feature-list-item {
            padding: 0.9rem;
            gap: 0.8rem;
          }

          .feature-icon {
            width: 20px;
            height: 20px;
          }

          .feature-text {
            font-size: 1rem;
          }

          .problem-card {
            padding: 1.5rem;
          }

          .problem-title {
            font-size: 1.1rem;
            gap: 0.5rem;
          }

          .problem-title svg {
            width: 18px;
            height: 18px;
          }

          .problem-description {
            font-size: 0.95rem;
          }

          .procedure-step {
            padding: 1.2rem 1.2rem 1.2rem 4.5rem;
            font-size: 0.95rem;
          }

          .procedure-step::before {
            width: 38px;
            height: 38px;
            font-size: 1.1rem;
            left: 1.2rem;
          }

          .faq-question {
            padding: 1.2rem 1.5rem;
            font-size: 1rem;
          }

          .faq-answer {
            padding: 0 1.5rem 1.2rem;
            font-size: 1rem;
          }

          /* Sidebar */
          .sidebar-card {
            padding: 2rem;
            border-radius: 20px;
          }

          .sidebar-title {
            font-size: 1.3rem;
          }

          .info-item {
            padding: 0.8rem 0;
          }

          .info-label {
            font-size: 0.9rem;
          }

          .info-value {
            font-size: 0.95rem;
          }

          .cta-card-title {
            font-size: 1.5rem;
          }

          .cta-card-text {
            font-size: 0.95rem;
          }

          .cta-contact-list {
            margin: 1.5rem 0;
            gap: 0.8rem;
          }

          .cta-contact-item {
            padding: 0.8rem;
            font-size: 0.9rem;
          }
        }

        @media (max-width: 480px) {
          .service-hero {
            min-height: 300px;
            padding: 2rem 0;
          }

          .service-hero-content {
            padding: 1rem;
          }

          .back-link {
            padding: 0.5rem 1rem;
            font-size: 0.85rem;
            margin-bottom: 1.2rem;
          }

          .back-link svg {
            width: 16px;
            height: 16px;
          }

          .service-icon-large {
            font-size: 2.5rem;
            margin-bottom: 0.6rem;
          }

          .service-category-badge {
            padding: 0.35rem 1rem;
            font-size: 0.75rem;
            letter-spacing: 1px;
          }

          .service-detail-title {
            font-size: 1.8rem;
            margin-bottom: 0.8rem;
          }

          .service-tagline {
            font-size: 1rem;
            margin-bottom: 1.2rem;
          }

          .meta-item {
            font-size: 0.9rem;
            gap: 0.5rem;
          }

          .meta-item svg {
            width: 18px;
            height: 18px;
          }

          /* Quick Contact Bar */
          .quick-contact-bar {
            padding: 0.8rem;
            margin-top: -20px;
          }

          .contact-item-compact {
            font-size: 0.85rem;
            gap: 0.5rem;
          }

          .contact-item-compact svg {
            width: 16px;
            height: 16px;
          }

          .book-button {
            padding: 0.8rem 1.5rem;
            font-size: 0.9rem;
            gap: 0.5rem;
          }

          .book-button svg {
            width: 18px;
            height: 18px;
          }

          /* Content */
          .service-content {
            padding: 1.5rem 0.8rem;
          }

          .content-section {
            padding: 1.5rem;
            border-radius: 15px;
            margin-bottom: 1.2rem;
          }

          .section-title {
            font-size: 1.5rem;
            gap: 0.6rem;
            margin-bottom: 1.2rem;
          }

          .section-title svg {
            width: 24px;
            height: 24px;
          }

          .section-text {
            font-size: 0.95rem;
            line-height: 1.6;
            margin-bottom: 1.5rem;
          }

          .feature-list {
            gap: 0.8rem;
          }

          .feature-list-item {
            padding: 0.8rem;
            gap: 0.7rem;
          }

          .feature-icon {
            width: 18px;
            height: 18px;
          }

          .feature-text {
            font-size: 0.95rem;
          }

          .problems-grid {
            gap: 1.2rem;
            margin-top: 1.5rem;
          }

          .problem-card {
            padding: 1.2rem;
            border-radius: 15px;
          }

          .problem-title {
            font-size: 1rem;
            margin-bottom: 0.6rem;
          }

          .problem-description {
            font-size: 0.9rem;
            line-height: 1.6;
          }

          .procedure-steps {
            gap: 1.2rem;
            margin-top: 1.5rem;
          }

          .procedure-step {
            padding: 1rem 1rem 1rem 4rem;
            font-size: 0.9rem;
            border-radius: 12px;
          }

          .procedure-step::before {
            width: 35px;
            height: 35px;
            font-size: 1rem;
            left: 1rem;
          }

          .faq-list {
            gap: 0.8rem;
          }

          .faq-item {
            border-radius: 12px;
          }

          .faq-question {
            padding: 1rem 1.2rem;
            font-size: 0.95rem;
          }

          .faq-question svg {
            width: 20px;
            height: 20px;
          }

          .faq-answer {
            padding: 0 1.2rem 1rem;
            font-size: 0.95rem;
            line-height: 1.6;
          }

          /* Sidebar */
          .sidebar-card {
            padding: 1.5rem;
            border-radius: 15px;
            margin-bottom: 1.5rem;
          }

          .sidebar-title {
            font-size: 1.2rem;
            margin-bottom: 1.2rem;
          }

          .info-item {
            padding: 0.7rem 0;
            flex-direction: column;
            align-items: flex-start;
            gap: 0.3rem;
          }

          .info-label,
          .info-value {
            font-size: 0.85rem;
          }

          .info-value {
            font-weight: 600;
          }

          .cta-card-title {
            font-size: 1.3rem;
            margin-bottom: 0.8rem;
          }

          .cta-card-text {
            font-size: 0.9rem;
            line-height: 1.6;
            margin-bottom: 1.2rem;
          }

          .cta-contact-list {
            margin: 1.2rem 0;
            gap: 0.6rem;
          }

          .cta-contact-item {
            padding: 0.7rem;
            font-size: 0.85rem;
            gap: 0.7rem;
          }

          .cta-contact-item svg {
            width: 16px;
            height: 16px;
          }

          .feature-badge {
            padding: 0.5rem 1rem;
            font-size: 0.85rem;
            gap: 0.4rem;
          }
        }

        @media (max-width: 360px) {
          .service-detail-title {
            font-size: 1.6rem;
          }

          .service-tagline {
            font-size: 0.95rem;
          }

          .section-title {
            font-size: 1.3rem;
          }

          .content-section {
            padding: 1.2rem;
          }

          .procedure-step {
            padding: 0.9rem 0.9rem 0.9rem 3.5rem;
          }

          .procedure-step::before {
            width: 32px;
            height: 32px;
            font-size: 0.95rem;
            left: 0.8rem;
          }

          .faq-question {
            font-size: 0.9rem;
          }
        }
      `}</style>

      <div className="service-detail-page">
        {/* Hero Section */}
        <section 
          className="service-hero"
          style={{backgroundImage: `url(${service.heroImage})`}}
        >
          <div className="service-hero-content">
            <Link to="/" className="back-link">
              <ArrowLeft size={20} />
              Back to Home
            </Link>
            
            <div className="service-icon-large">{service.icon}</div>
            <div className="service-category-badge">{service.category}</div>
            <h1 className="service-detail-title">{service.title}</h1>
            <p className="service-tagline">{service.tagline}</p>
            
            <div className="service-meta">
              <div className="meta-item">
                <Clock size={20} />
                <span>{service.duration}</span>
              </div>
              <div className="meta-item">
                <AlertCircle size={20} />
                <span>{service.preparation}</span>
              </div>
            </div>
          </div>
        </section>

        {/* Quick Contact Bar */}
        <div className="quick-contact-bar">
          <div className="quick-contact-content">
            <div className="contact-info-compact">
              <div className="contact-item-compact">
                <Phone size={18} />
                <a href="tel:+919989162222">+91 99891 62222</a>
              </div>
              <div className="contact-item-compact">
                <Mail size={18} />
                <a href="mailto:vayulungcare@gmail.com">vayulungcare@gmail.com</a>
              </div>
            </div>
            <Link to="/contact" className="book-button">
              <Calendar size={20} />
              Book Appointment
            </Link>
          </div>
        </div>

        {/* Main Content */}
        <div className="service-content">
          <div className="content-grid">
            {/* Main Column */}
            <div>
              {/* Overview */}
              <div className="content-section">
                <h2 className="section-title">
                  <Info size={32} />
                  Overview
                </h2>
                <p className="section-text">{service.overview}</p>
              </div>

              {/* What We Offer */}
              <div className="content-section">
                <h2 className="section-title">
                  <Shield size={32} />
                  What We Offer
                </h2>
                <div className="feature-list">
                  {service.whatWeOffer.map((item, index) => (
                    <div key={index} className="feature-list-item">
                      <CheckCircle size={22} className="feature-icon" />
                      <span className="feature-text">{item}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Problems Solved */}
              <div className="content-section">
                <h2 className="section-title">
                  <Heart size={32} />
                  Problems We Solve
                </h2>
                <div className="problems-grid">
                  {service.problemsSolved.map((problem, index) => (
                    <div key={index} className="problem-card">
                      <h3 className="problem-title">
                        <CheckCircle size={20} />
                        {problem.title}
                      </h3>
                      <p className="problem-description">{problem.description}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* Procedure */}
              <div className="content-section">
                <h2 className="section-title">
                  <Award size={32} />
                  What to Expect
                </h2>
                <div className="procedure-steps">
                  {service.procedure.map((step, index) => (
                    <div key={index} className="procedure-step">
                      {step}
                    </div>
                  ))}
                </div>
              </div>

              {/* FAQs */}
              <div className="content-section">
                <h2 className="section-title">
                  <AlertCircle size={32} />
                  Frequently Asked Questions
                </h2>
                <div className="faq-list">
                  {service.faqs.map((faq, index) => (
                    <div 
                      key={index} 
                      className={`faq-item ${openFAQ === index ? 'open' : ''}`}
                    >
                      <div 
                        className="faq-question"
                        onClick={() => toggleFAQ(index)}
                      >
                        <span>{faq.question}</span>
                        {openFAQ === index ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
                      </div>
                      {openFAQ === index && (
                        <div className="faq-answer">
                          {faq.answer}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Sidebar */}
            <div className="sidebar">
              {/* Quick Info */}
              <div className="sidebar-card">
                <h3 className="sidebar-title">Quick Information</h3>
                <div className="info-item">
                  <span className="info-label">Duration</span>
                  <span className="info-value">{service.duration}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Category</span>
                  <span className="info-value">{service.category}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Preparation</span>
                  <span className="info-value">{service.preparation}</span>
                </div>
              </div>

              {/* CTA Card */}
              <div className="sidebar-card cta-card" id="book-appointment">
                <h3 className="cta-card-title">Ready to Book?</h3>
                <p className="cta-card-text">
                  Schedule your appointment today and take the first step towards better health
                </p>
                
                <div className="cta-contact-list">
                  <div className="cta-contact-item">
                    <Phone size={20} />
                    <a href="tel:+919989162222">+91 99891 62222</a>
                  </div>
                  <div className="cta-contact-item">
                    <Mail size={20} />
                    <a href="mailto:vayulungcare@gmail.com">vayulungcare@gmail.com</a>
                  </div>
                </div>

                <Link to="/contact" className="book-button" style={{width: '100%', justifyContent: 'center'}}>
                  <Calendar size={20} />
                  Book Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceDetailPage;